import { __extends, __values } from "tslib";
import * as React from 'react';
import { HorizontalAlignment_$type } from "igniteui-react-core";
import { UnknownValuePlotting_$type } from "igniteui-react-core";
import { TrendLineType_$type } from "igniteui-react-core";
import { IgrChartSeriesEventArgs } from './igr-chart-series-event-args';
import { arrayFindByName, brushToString, stringToBrush, toBrushCollection, fromBrushCollection, fromRect, toRect, ensureBool, ensureEnum, isValidProp, getModifiedProps, toSpinal, initializePropertiesFromCss, NamePatcher } from "igniteui-react-core";
import { MarkerType_$type } from "./MarkerType";
import { delegateCombine, delegateRemove } from "igniteui-react-core";
import { IgrDomainChartSeriesPointerEventArgs } from './igr-domain-chart-series-pointer-event-args';
import { MarkerTypeCollection as MarkerTypeCollection_internal } from './MarkerTypeCollection';
import { IgrMarkerTypeCollection } from './igr-marker-type-collection';
import { SyncableObservableCollection$1 } from "igniteui-react-core";
import { ToolTipType_$type } from "./ToolTipType";
import { CrosshairsDisplayMode_$type } from "./CrosshairsDisplayMode";
import { IgrCalloutStyleUpdatingEventArgs } from "./igr-callout-style-updating-event-args";
import { ComputedPlotAreaMarginMode_$type } from './ComputedPlotAreaMarginMode';
import { SeriesHighlightingMode_$type } from './SeriesHighlightingMode';
import { SeriesHighlightingBehavior_$type } from './SeriesHighlightingBehavior';
import { LegendHighlightingMode_$type } from './LegendHighlightingMode';
import { SeriesOutlineMode_$type } from './SeriesOutlineMode';
import { MarkerOutlineMode_$type } from './MarkerOutlineMode';
import { MarkerFillMode_$type } from './MarkerFillMode';
import { MarkerAutomaticBehavior_$type } from './MarkerAutomaticBehavior';
import { LegendItemBadgeMode_$type } from "igniteui-react-core";
import { LegendItemBadgeShape_$type } from "igniteui-react-core";
import { DataAbbreviationMode_$type } from "igniteui-react-core";
import { DataLegendValueMode_$type } from "igniteui-react-core";
import { DataLegendHeaderDateMode_$type } from "igniteui-react-core";
import { DataLegendHeaderTimeMode_$type } from "igniteui-react-core";
import { DataLegendUnitsMode_$type } from "igniteui-react-core";
import { DataLegendLabelMode_$type } from "igniteui-react-core";
import { DataLegendSummaryType_$type } from "igniteui-react-core";
import { Thickness } from "igniteui-react-core";
import { FontInfo } from "igniteui-react-core";
import { SeriesPlotAreaMarginHorizontalMode_$type } from './SeriesPlotAreaMarginHorizontalMode';
import { SeriesPlotAreaMarginVerticalMode_$type } from './SeriesPlotAreaMarginVerticalMode';
import { IgrCalloutPlacementPositionsCollection } from './igr-callout-placement-positions-collection';
import { CalloutPlacementPositions_$type } from './CalloutPlacementPositions';
import { SeriesViewerScrollbarMode_$type } from './SeriesViewerScrollbarMode';
import { SeriesViewerHorizontalScrollbarPosition_$type } from './SeriesViewerHorizontalScrollbarPosition';
import { SeriesViewerVerticalScrollbarPosition_$type } from './SeriesViewerVerticalScrollbarPosition';
import { IgrCalloutRenderStyleUpdatingEventArgs } from './igr-callout-render-style-updating-event-args';
import { CalloutPlacementPositionsCollection as CalloutPlacementPositionsCollection_internal } from './CalloutPlacementPositionsCollection';
import { DataToolTipLayerGroupingMode_$type } from "igniteui-react-core";
import { DataTooltipGroupedPositionX_$type } from "igniteui-react-core";
import { DataTooltipGroupedPositionY_$type } from "igniteui-react-core";
import { IgrChartSummaryDescriptionCollection } from './igr-chart-summary-description-collection';
import { IgrChartSortDescriptionCollection } from './igr-chart-sort-description-collection';
import { IgrFilterExpressionCollection } from "igniteui-react-core";
import { ValueModeCollection as ValueModeCollection_internal } from './ValueModeCollection';
import { IgrValueModeCollection } from './igr-value-mode-collection';
import { ValueLayerValueMode_$type } from './ValueLayerValueMode';
var IgrDomainChart = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(IgrDomainChart, _super);
    function IgrDomainChart(props) {
        var _this = _super.call(this, props) || this;
        _this._calloutsDataSource = null;
        _this._markerTypes = null;
        _this._calloutsAllowedPositions = null;
        _this._valueLines = null;
        _this.__p = null;
        _this._hasUserValues = new Set();
        _this._stylingContainer = null;
        _this._stylingParent = null;
        _this._inStyling = false;
        _this._seriesAdded = null;
        _this._seriesAdded_wrapped = null;
        _this._seriesRemoved = null;
        _this._seriesRemoved_wrapped = null;
        _this._seriesPointerEnter = null;
        _this._seriesPointerEnter_wrapped = null;
        _this._seriesPointerLeave = null;
        _this._seriesPointerLeave_wrapped = null;
        _this._seriesPointerMove = null;
        _this._seriesPointerMove_wrapped = null;
        _this._seriesPointerDown = null;
        _this._seriesPointerDown_wrapped = null;
        _this._seriesPointerUp = null;
        _this._seriesPointerUp_wrapped = null;
        _this._calloutStyleUpdating = null;
        _this._calloutStyleUpdating_wrapped = null;
        _this._calloutRenderStyleUpdating = null;
        _this._calloutRenderStyleUpdating_wrapped = null;
        if (_this._styling) {
            NamePatcher.ensureStylablePatched(Object.getPrototypeOf(_this));
        }
        _this._implementation = _this.createImplementation();
        _this._implementation.externalObject = _this;
        _this.onImplementationCreated();
        return _this;
    }
    IgrDomainChart.prototype.createImplementation = function () {
        return null;
    };
    Object.defineProperty(IgrDomainChart.prototype, "i", {
        get: function () {
            return this._implementation;
        },
        enumerable: false,
        configurable: true
    });
    IgrDomainChart.prototype.onImplementationCreated = function () {
    };
    IgrDomainChart.prototype.componentDidMount = function () {
        var e_1, _a;
        try {
            for (var _b = __values(Object.keys(this.props)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var p = _c.value;
                if (isValidProp(this, p)) {
                    this[p] = this.props[p];
                }
            }
        }
        catch (e_1_1) {
            e_1 = { error: e_1_1 };
        }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return))
                    _a.call(_b);
            }
            finally {
                if (e_1)
                    throw e_1.error;
            }
        }
    };
    IgrDomainChart.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        var e_2, _a;
        var mod = getModifiedProps(this.props, nextProps);
        try {
            for (var _b = __values(Object.keys(mod)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var p = _c.value;
                if (isValidProp(this, p)) {
                    this[p] = mod[p];
                }
            }
        }
        catch (e_2_1) {
            e_2 = { error: e_2_1 };
        }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return))
                    _a.call(_b);
            }
            finally {
                if (e_2)
                    throw e_2.error;
            }
        }
        return true;
    };
    IgrDomainChart.prototype.render = function () {
        return null;
    };
    Object.defineProperty(IgrDomainChart.prototype, "tooltipTemplate", {
        /**
        * Sets or gets the template reference to use for tooltips for all the series.
        *
        *
        */
        get: function () {
            return this.i.tooltipTemplate;
        },
        set: function (v) {
            this.i.tooltipTemplate = v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "tooltipTemplates", {
        /**
        * Sets or gets the template references to use for tooltips for all the series, in order.
        *
        *
        */
        get: function () {
            var ret = [];
            if (this.i.tooltipTemplates) {
                for (var ii = 0; ii < this.i.tooltipTemplates.count; ii++) {
                    ret.push(this.i.tooltipTemplates.item(ii));
                }
            }
            return ret;
        },
        set: function (v) {
            this.i.tooltipTemplates.clear();
            if (v) {
                for (var ii = 0; ii < v.length; ii++) {
                    this.i.tooltipTemplates.add(v[ii]);
                }
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "legend", {
        get: function () {
            if (this.i.legend != null)
                return this.i.legend.externalObject;
        },
        set: function (v) {
            if (v != undefined && v != null)
                this.i.legend = v.i;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "calloutsDataSource", {
        get: function () {
            return this._calloutsDataSource;
        },
        set: function (value) {
            this._calloutsDataSource = value;
            this.bindCalloutsData();
        },
        enumerable: false,
        configurable: true
    });
    IgrDomainChart.prototype.bindCalloutsData = function () {
        if (this.i != null && this.i !== undefined) {
            this.i.calloutsItemsSource = this._calloutsDataSource;
        }
    };
    Object.defineProperty(IgrDomainChart.prototype, "pixelScalingRatio", {
        /**
     * Gets or sets the scaling value used to affect the pixel density of the control.
     * A higher scaling ratio will produce crisper visuals at the expense of memory.  Lower values will cause the control
     * to appear blurry.
    */
        get: function () {
            return this.i.iq;
        },
        set: function (v) {
            this.i.iq = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "titleLeftMargin", {
        /**
         * Gets or sets the left margin of chart title
        *
        *  Use `titleLeftMargin` property for the left margin of chart title.
        *
        * ```ts
        * this.chart.titleLeftMargin = 10;
        * ```
        *
        * ```ts
        *  <IgrCategoryChart dataSource={this.state.data}
        *                    titleLeftMargin={20}>
        *  </IgrCategoryChart>
        * ```
        */
        get: function () {
            return this.i.i3;
        },
        set: function (v) {
            this.i.i3 = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "titleRightMargin", {
        /**
         * Gets or sets the right margin of chart title
        *
        *  Use `titleLeftMargin` property for the right margin of chart title.
        *
        * ```ts
        * this.chart.titleRightMargin = 10;
        * ```
        *
        * ```ts
        * <IgrCategoryChart
        * 				dataSource={this.state.data}
        *                 titleRightMargin = 10>
        *  </IgrCategoryChart>
        * ```
        */
        get: function () {
            return this.i.i4;
        },
        set: function (v) {
            this.i.i4 = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "titleTopMargin", {
        /**
         * Gets or sets the top margin of chart title
        *
        *  Use `titleTopMargin` property for the top margin of chart title.
        *
        * ```ts
        * this.chart.titleTopMargin = 10;
        * ```
        *
        * ```ts
        * <IgrCategoryChart dataSource={this.state.data}
        *                titleTopMargin={10} />
        * ```
        */
        get: function () {
            return this.i.i5;
        },
        set: function (v) {
            this.i.i5 = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "titleBottomMargin", {
        /**
         * Gets or sets the bottom margin of chart title
        *
        *  Use `titleBottomMargin` property for the bottom margin of chart title.
        *
        * ```ts
        *  this.chart.titleBottomMargin = 5;
        * ```
        *
        * ```ts
        *  <IgrCategoryChart
        * 	width="100%"
        * 	height="100%"
        * 	chartType="Line"
        * 	dataSource={this.categoryData}
        * 	subtitle= "CategoryChart Subtitle"
        * 	subtitleAlignment="Right"
        * 	titleBottomMargin={5}/>
        * ```
        */
        get: function () {
            return this.i.i2;
        },
        set: function (v) {
            this.i.i2 = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "subtitleLeftMargin", {
        /**
         * Gets or sets the left margin of chart subtitle
        *
        * Use `subtitleLeftMargin` property for the left margin of chart subtitle.
        *
        * ```ts
        * this.chart.subtitleLeftMargin = 20 ;
        * ```
        *
        * ```ts
        *  <IgrCategoryChart
        * 	width="100%"
        * 	height="100%"
        * 	chartType="Line"
        * 	dataSource={this.categoryData}
        * 	subtitle= "CategoryChart Subtitle"
        * 	subtitleLeftMargin= {20}/>
        * ```
        */
        get: function () {
            return this.i.iy;
        },
        set: function (v) {
            this.i.iy = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "subtitleTopMargin", {
        /**
         * Gets or sets the top margin of chart subtitle
        *
        * Use `subtitleTopMargin` property for the top margin of chart subtitle.
        *
        * ```ts
        * this.chart.subtitleTopMargin = 10;
        * ```
        *
        * ```ts
        *  <IgrCategoryChart
        * 	width="100%"
        * 	height="100%"
        * 	chartType="Line"
        * 	dataSource={this.categoryData}
        * 	subtitle= "CategoryChart Subtitle"
        * 	subtitleTopMargin= {10}/>
        * ```
        */
        get: function () {
            return this.i.i0;
        },
        set: function (v) {
            this.i.i0 = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "subtitleRightMargin", {
        /**
         * Gets or sets the right margin of chart subtitle
        *
        * Use `subtitleRightMargin` property for the right margin of chart subtitle.
        *
        * ```ts
        *  this.chart.subtitleRightMargin = 20 ;
        * ```
        *
        * ```ts
        *  <IgrCategoryChart
        * 	width="100%"
        * 	height="100%"
        * 	chartType="Line"
        * 	dataSource={this.categoryData}
        * 	subtitle= "CategoryChart Subtitle"
        * 	subtitleAlignment="Right"
        * 	subtitleRightMargin ={20}/>
        * ```
        */
        get: function () {
            return this.i.iz;
        },
        set: function (v) {
            this.i.iz = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "subtitleBottomMargin", {
        /**
         * Gets or sets the bottom margin of chart subtitle
        *
        * Use `subtitleBottomMargin` property for the bottom margin of chart subtitle.
        *
        * ```ts
        *  <IgrCategoryChart
        * 	width="100%"
        * 	height="100%"
        * 	chartType="Line"
        * 	dataSource={this.categoryData}
        * 	subtitle= "CategoryChart Subtitle"
        * 	subtitleBottomMargin= {10}/>
        * ```
        *
        * ```ts
        * this.chart.subtitleBottomMargin = 10 ;
        * ```
        */
        get: function () {
            return this.i.ix;
        },
        set: function (v) {
            this.i.ix = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "subtitleTextColor", {
        /**
         * Gets or sets color of chart subtitle
        *
        * Use `subtitleTextColor` property to color the subtitle.
        *
        * ```ts
        * this.chart.subtitleTextColor = "#ff0000" ;
        * ```
        *
        * ```ts
        *  <IgrCategoryChart
        * 	width="100%"
        * 	height="100%"
        * 	chartType="Line"
        * 	dataSource={this.categoryData}
        * 	subtitle= "CategoryChart Subtitle"
        * 	subtitleTextColor="#ff0000"/>
        * ```
        */
        get: function () {
            return brushToString(this.i.u8);
        },
        set: function (v) {
            this.i.u8 = stringToBrush(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "titleTextColor", {
        /**
         * Gets or sets color of chart title
        *
        *  Use `titleTextColor` property to color the chart title
        *
        * ```ts
        *  this.chart.titleTextColor="red" ;
        * ```
        *
        * ```ts
        * <IgrCategoryChart
        * 		dataSource={this.state.data}
        * 		width="700px"
        * 		height="500px"
        * 		xAxisTitle="Countries"
        * 		titleTextColor="Red" />
        *
        * ```
        */
        get: function () {
            return brushToString(this.i.u9);
        },
        set: function (v) {
            this.i.u9 = stringToBrush(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "leftMargin", {
        /**
         * Gets or sets the left margin of the chart content.
        *
        * Use the 'leftMargin' property for the left margin of the chart content.
        *
        * ```ts
        *  this.chart.leftMargin = 20;
        * ```
        *
        * ```ts
        *  <IgrCategoryChart dataSource={this.state.data}
        *                    leftMargin= {20}/>
        * ```
        */
        get: function () {
            return this.i.im;
        },
        set: function (v) {
            this.i.im = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "topMargin", {
        /**
         * Gets or sets the top margin of the chart content.
        *
        * Use `topMargin` property for the margin of the chart content.
        *
        * ```ts
        * this.chart.topMargin=20;
        * ```
        *
        * ```ts
        * <IgrCategoryChart dataSource={this.state.data}
        *                topMargin={10} />
        * ```
        */
        get: function () {
            return this.i.i6;
        },
        set: function (v) {
            this.i.i6 = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "rightMargin", {
        /**
         * Gets or sets the right margin of the chart content.
        *
        * Use `rightMargin` property for the right margin of the chart content.
        *
        * ```ts
        *   this.chart.rightMargin = 20 ;
        * ```
        *
        * ```ts
        *  <IgrCategoryChart
        * 	width="100%"
        * 	height="100%"
        * 	chartType="Line"
        * 	markerTypes={this.state.markersTypes}
        * 	dataSource={this.categoryData}
        * 	rightMargin= {4}/>
        * ```
        */
        get: function () {
            return this.i.iw;
        },
        set: function (v) {
            this.i.iw = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "bottomMargin", {
        /**
         * Gets or sets the bottom margin around the chart content.
        *
        * Use the `bottomMargin` property for the bottom margin around the chart content.
        *
        * ```ts
        * this.chart.bottomMargin=20;
        * ```
        *
        * ```ts
        *  <IgrCategoryChart dataSource={this.state.data}
        *                    bottomMargin= 20 />
        * ```
        */
        get: function () {
            return this.i.h8;
        },
        set: function (v) {
            this.i.h8 = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "transitionDuration", {
        /**
         * Gets or sets the duration used for animating series plots when the data is changing
        *
        * Use the `TransitionDuration` property to animating between data values.
        *
        * ```ts
        * this.chart.transitionDuratio= 500;
        * ```
        *
        * ```ts
        * <IgrCategoryChart dataSource={this.state.data}
        *                transitionDuratio={500} />
        * ```
        */
        get: function () {
            return this.i.j1;
        },
        set: function (v) {
            this.i.j1 = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "transitionEasingFunction", {
        /**
         * Gets or sets the easing function used for animating series plots when the data is changing.
         * This can be set to one of the known values "linear" or "cubic," or it can be set to an easing function which takes a single numeric parameter and returns a number.
        *
        * The 'transitionInEasingFunction' property used for easing function for animating series plots when the chart is loading into view.
        *
        * ```ts
        * this.chart.transitionInEasingFunction=  this.cubicFunc;
        *
        * cubicFunc(time: number) : number
        *   {
        *     return time;
        *   }
        * ```
        *
        * ```ts
        * <IgrCategoryChart dataSource={this.state.data}
        *                transitionInEasingFunction="cubic" />
        * ```
        */
        get: function () {
            return this.i.d3;
        },
        set: function (v) {
            this.i.d3 = v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "subtitleTextStyle", {
        /**
         * Gets or sets CSS font property for the chart subtitle
        *
        * Use `subtitleTextStyle` property for the CSS font of the chart subtitle.
        *
        * ```ts
        * this.chart.subtitleTextStyle= "16pt Verdona";
        * ```
        *
        * ```ts
        *  <IgrCategoryChart
        * 	width="100%"
        * 	height="100%"
        * 	chartType="Line"
        * 	dataSource={this.categoryData}
        * 	subtitleTextStyle="16pt Verdona"/>
        * ```
        */
        get: function () {
            return this.i.p7;
        },
        set: function (v) {
            this.i.p7 = v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "titleTextStyle", {
        /**
         * Gets or sets CSS font property for the chart title
        *
        * Use `titleTextStyle` property for the CSS font property of the chart title
        *
        * ```ts
        * this.chart.xAxisTitleTextStyle = "24pt Verdona";
        * ```
        *
        * ```ts
        * <IgrCategoryChart dataSource={this.state.data}
        *                 width="700px"
        *                 height="500px"
        *                 xAxisTitle="Countries"
        *                 xAxisTitleTextColor="gray"
        *                 xAxisTitleTextStyle="12pt Verdana"
        *                 xAxisTitleAngle={0}
        *                 yAxisTitle="Trillions of Watt-hours (TWh)"
        *                 yAxisTitleTextStyle="12pt Verdana"
        *                 yAxisTitleTextColor="gray"
        *                 yAxisTitleAngle={90}
        *                 yAxisTitleLeftMargin={5}>
        *  </IgrCategoryChart>
        * ```
        */
        get: function () {
            return this.i.qi;
        },
        set: function (v) {
            this.i.qi = v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "dataToolTipGroupingMode", {
        get: function () {
            return this.i.bv;
        },
        set: function (v) {
            this.i.bv = ensureEnum(DataToolTipLayerGroupingMode_$type, v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "dataToolTipPositionOffsetX", {
        /**
         * Gets or sets the offset of the tooltip layer on the X axis.
        */
        get: function () {
            return this.i.ic;
        },
        set: function (v) {
            this.i.ic = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "dataToolTipPositionOffsetY", {
        /**
         * Gets or sets the offset of the tooltip layer on the Y axis.
        */
        get: function () {
            return this.i.id;
        },
        set: function (v) {
            this.i.id = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "dataToolTipDefaultPositionOffsetX", {
        /**
         * Gets or sets the offset of the tooltip layer on the X axis.
        */
        get: function () {
            return this.i.ia;
        },
        set: function (v) {
            this.i.ia = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "dataToolTipDefaultPositionOffsetY", {
        /**
         * Gets or sets the offset of the tooltip layer on the Y axis.
        */
        get: function () {
            return this.i.ib;
        },
        set: function (v) {
            this.i.ib = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "dataToolTipGroupedPositionModeX", {
        /**
         * Gets or sets the tooltip position mode on the X axis for grouped series.
        */
        get: function () {
            return this.i.br;
        },
        set: function (v) {
            this.i.br = ensureEnum(DataTooltipGroupedPositionX_$type, v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "dataToolTipGroupedPositionModeY", {
        /**
         * Gets or sets the tooltip position mode on the Y axis for grouped series.
        */
        get: function () {
            return this.i.bt;
        },
        set: function (v) {
            this.i.bt = ensureEnum(DataTooltipGroupedPositionY_$type, v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "dataToolTipShouldUpdateWhenSeriesDataChanges", {
        /**
         * Gets or sets whether the data legend should update when the series data is mutated.
        */
        get: function () {
            return this.i.fp;
        },
        set: function (v) {
            this.i.fp = ensureBool(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "dataToolTipIncludedSeries", {
        /**
         * Gets or sets indexes or names of series to include in displaying in the data legend, e.g. "0, 1"
        */
        get: function () {
            return this.i.m;
        },
        set: function (v) {
            if (v && !Array.isArray(v) && typeof (v) == "string") {
                var re = /\s*(?:,|\s|$)\s*/gm;
                v = v.split(re);
            }
            this.i.m = v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "dataToolTipExcludedSeries", {
        /**
         * Gets or sets indexes or names of series to exclude from displaying in the data legend, e.g. "0, 1"
         * The ExcludedSeries property takes precedences over values of IncludedSeries property
        */
        get: function () {
            return this.i.j;
        },
        set: function (v) {
            if (v && !Array.isArray(v) && typeof (v) == "string") {
                var re = /\s*(?:,|\s|$)\s*/gm;
                v = v.split(re);
            }
            this.i.j = v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "dataToolTipIncludedColumns", {
        /**
         * Gets or sets names of data columns or their labels to include in displaying in the data legend, e.g. "High, Low" or "H, L"
         * The ExcludedColumns property takes precedences over values of IncludedColumns property
        */
        get: function () {
            return this.i.l;
        },
        set: function (v) {
            if (v && !Array.isArray(v) && typeof (v) == "string") {
                var re = /\s*(?:,|\s|$)\s*/gm;
                v = v.split(re);
            }
            this.i.l = v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "dataToolTipExcludedColumns", {
        /**
         * Gets or sets names of data columns or their labels to exclude from displaying in the data legend, e.g. "High, Low" or "H, L"
         * The ExcludedColumns property takes precedences over values of IncludedColumns property
        */
        get: function () {
            return this.i.i;
        },
        set: function (v) {
            if (v && !Array.isArray(v) && typeof (v) == "string") {
                var re = /\s*(?:,|\s|$)\s*/gm;
                v = v.split(re);
            }
            this.i.i = v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "dataToolTipValueFormatAbbreviation", {
        /**
         * Gets or sets mode for abbreviating large numbers displayed in the legend
         * This property is ignored when setting ValueFormatSpecifiers or ValueFormatString properties
        */
        get: function () {
            return this.i.bb;
        },
        set: function (v) {
            this.i.bb = ensureEnum(DataAbbreviationMode_$type, v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "dataToolTipValueFormatMaxFractions", {
        /**
         * Gets or sets maximum digits for formating numbers displayed in the legend
         * This property is ignored when setting ValueFormatSpecifiers or ValueFormatString properties
        */
        get: function () {
            return this.i.jx;
        },
        set: function (v) {
            this.i.jx = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "dataToolTipValueFormatMinFractions", {
        /**
         * Gets or sets minimum digits for formating numbers displayed in the legend
         * This property is ignored when setting ValueFormatSpecifiers or ValueFormatString properties
        */
        get: function () {
            return this.i.jy;
        },
        set: function (v) {
            this.i.jy = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "dataToolTipValueFormatMode", {
        /**
         * Gets or sets the mode for displaying values in the data legend, e.g. Currency ($500.25), Decimal (500.25), Integer (500)
        */
        get: function () {
            return this.i.bp;
        },
        set: function (v) {
            this.i.bp = ensureEnum(DataLegendValueMode_$type, v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "dataToolTipValueFormatCulture", {
        /**
         * Gets or sets globalization culture when displaying values as currencies, e.g. use "en-GB" to display British pound symbol when the ValueFormatMode property is set to 'Currency' mode
         * This property is ignored when setting ValueFormatSpecifiers or ValueFormatString properties
        */
        get: function () {
            return this.i.nr;
        },
        set: function (v) {
            this.i.nr = v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "dataToolTipValueFormatUseGrouping", {
        /**
         * Gets or sets whether or not use grouping separator, e.g, 15,000 for 15000
         * This property is ignored when setting ValueFormatSpecifiers or ValueFormatString properties
        */
        get: function () {
            return this.i.fq;
        },
        set: function (v) {
            this.i.fq = ensureBool(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "dataToolTipValueFormatString", {
        /**
         * Gets or sets the format string for values displayed in the data legend.
        */
        get: function () {
            return this.i.nx;
        },
        set: function (v) {
            this.i.nx = v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "dataToolTipValueFormatSpecifiers", {
        /**
         * Gets or sets the format specifiers to use with the ValueFormatString string.
        */
        get: function () {
            return this.i.n;
        },
        set: function (v) {
            if (v && !Array.isArray(v) && typeof (v) == "string") {
                var re = /\s*(?:,|\s|$)\s*/gm;
                v = v.split(re);
            }
            this.i.n = v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "dataToolTipValueRowMarginBottom", {
        get: function () {
            return this.i.vy ? this.i.vy.bottom : NaN;
        },
        set: function (v) {
            this.ensureDataToolTipValueRowMargin();
            this.i.vy.bottom = +v;
            this.i.vy = this.i.vy;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "dataToolTipValueRowMarginLeft", {
        get: function () {
            return this.i.vy ? this.i.vy.left : NaN;
        },
        set: function (v) {
            this.ensureDataToolTipValueRowMargin();
            this.i.vy.left = +v;
            this.i.vy = this.i.vy;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "dataToolTipValueRowMarginRight", {
        get: function () {
            return this.i.vy ? this.i.vy.right : NaN;
        },
        set: function (v) {
            this.ensureDataToolTipValueRowMargin();
            this.i.vy.right = +v;
            this.i.vy = this.i.vy;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "dataToolTipValueRowMarginTop", {
        get: function () {
            return this.i.vy ? this.i.vy.top : NaN;
        },
        set: function (v) {
            this.ensureDataToolTipValueRowMargin();
            this.i.vy.top = +v;
            this.i.vy = this.i.vy;
        },
        enumerable: false,
        configurable: true
    });
    IgrDomainChart.prototype.ensureDataToolTipValueRowMargin = function () {
        if (this.i.vy) {
            return;
        }
        this.i.vy = new Thickness(2);
    };
    Object.defineProperty(IgrDomainChart.prototype, "dataToolTipValueRowVisible", {
        /**
         * Gets or sets whether to show series rows.
        */
        get: function () {
            return this.i.fr;
        },
        set: function (v) {
            this.i.fr = ensureBool(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "dataToolTipValueTextWhenMissingData", {
        /**
         * Gets or sets text displayed when data column is missing a value, e.g. "no data"
        */
        get: function () {
            return this.i.n6;
        },
        set: function (v) {
            this.i.n6 = v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "dataToolTipValueTextUseSeriesColors", {
        /**
         * Gets or sets whether to use series colors when displaying values in the legend
        */
        get: function () {
            return this.i.fs;
        },
        set: function (v) {
            this.i.fs = ensureBool(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "dataToolTipValueTextMarginBottom", {
        get: function () {
            return this.i.vz ? this.i.vz.bottom : NaN;
        },
        set: function (v) {
            this.ensureDataToolTipValueTextMargin();
            this.i.vz.bottom = +v;
            this.i.vz = this.i.vz;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "dataToolTipValueTextMarginLeft", {
        get: function () {
            return this.i.vz ? this.i.vz.left : NaN;
        },
        set: function (v) {
            this.ensureDataToolTipValueTextMargin();
            this.i.vz.left = +v;
            this.i.vz = this.i.vz;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "dataToolTipValueTextMarginRight", {
        get: function () {
            return this.i.vz ? this.i.vz.right : NaN;
        },
        set: function (v) {
            this.ensureDataToolTipValueTextMargin();
            this.i.vz.right = +v;
            this.i.vz = this.i.vz;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "dataToolTipValueTextMarginTop", {
        get: function () {
            return this.i.vz ? this.i.vz.top : NaN;
        },
        set: function (v) {
            this.ensureDataToolTipValueTextMargin();
            this.i.vz.top = +v;
            this.i.vz = this.i.vz;
        },
        enumerable: false,
        configurable: true
    });
    IgrDomainChart.prototype.ensureDataToolTipValueTextMargin = function () {
        if (this.i.vz) {
            return;
        }
        this.i.vz = new Thickness(2);
    };
    Object.defineProperty(IgrDomainChart.prototype, "dataToolTipValueTextColor", {
        /**
         * Gets or sets the units text color.
        */
        get: function () {
            return brushToString(this.i.uy);
        },
        set: function (v) {
            this.i.uy = stringToBrush(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "dataToolTipValueTextStyle", {
        /**
         * Gets or Sets the style to use for the units text.
        */
        get: function () {
            if (this.i.el == null) {
                return null;
            }
            return this.i.el.fontString;
        },
        set: function (v) {
            var fi = new FontInfo();
            fi.fontString = v;
            this.i.el = fi;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "dataToolTipHeaderFormatString", {
        /**
         * Gets or sets the format string for header text displayed in the data legend.
        */
        get: function () {
            return this.i.mh;
        },
        set: function (v) {
            this.i.mh = v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "dataToolTipHeaderFormatSpecifiers", {
        /**
         * Gets or sets the format specifiers to use with the HeaderFormatString string.
        */
        get: function () {
            return this.i.k;
        },
        set: function (v) {
            if (v && !Array.isArray(v) && typeof (v) == "string") {
                var re = /\s*(?:,|\s|$)\s*/gm;
                v = v.split(re);
            }
            this.i.k = v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "dataToolTipHeaderFormatCulture", {
        /**
         * Gets or sets globalization culture when displaying header as date time
         * This property is ignored when setting HeaderFormatSpecifiers or HeaderFormatString properties
        */
        get: function () {
            return this.i.md;
        },
        set: function (v) {
            this.i.md = v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "dataToolTipHeaderFormatDate", {
        /**
         * Gets or sets date format for the header
         * This property is ignored when setting HeaderFormatSpecifiers or HeaderFormatString properties
        */
        get: function () {
            return this.i.bf;
        },
        set: function (v) {
            this.i.bf = ensureEnum(DataLegendHeaderDateMode_$type, v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "dataToolTipHeaderFormatTime", {
        /**
         * Gets or sets time format for the header
         * This property is ignored when setting HeaderFormatSpecifiers or HeaderFormatString properties
        */
        get: function () {
            return this.i.bh;
        },
        set: function (v) {
            this.i.bh = ensureEnum(DataLegendHeaderTimeMode_$type, v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "dataToolTipHeaderText", {
        /**
         * Gets or sets the HeaderText for the data legend.
        */
        get: function () {
            return this.i.mm;
        },
        set: function (v) {
            this.i.mm = v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "dataToolTipHeaderTextColor", {
        /**
         * Gets or sets the header text color.
        */
        get: function () {
            return brushToString(this.i.uq);
        },
        set: function (v) {
            this.i.uq = stringToBrush(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "dataToolTipHeaderTextMarginBottom", {
        get: function () {
            return this.i.vs ? this.i.vs.bottom : NaN;
        },
        set: function (v) {
            this.ensureDataToolTipHeaderTextMargin();
            this.i.vs.bottom = +v;
            this.i.vs = this.i.vs;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "dataToolTipHeaderTextMarginLeft", {
        get: function () {
            return this.i.vs ? this.i.vs.left : NaN;
        },
        set: function (v) {
            this.ensureDataToolTipHeaderTextMargin();
            this.i.vs.left = +v;
            this.i.vs = this.i.vs;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "dataToolTipHeaderTextMarginRight", {
        get: function () {
            return this.i.vs ? this.i.vs.right : NaN;
        },
        set: function (v) {
            this.ensureDataToolTipHeaderTextMargin();
            this.i.vs.right = +v;
            this.i.vs = this.i.vs;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "dataToolTipHeaderTextMarginTop", {
        get: function () {
            return this.i.vs ? this.i.vs.top : NaN;
        },
        set: function (v) {
            this.ensureDataToolTipHeaderTextMargin();
            this.i.vs.top = +v;
            this.i.vs = this.i.vs;
        },
        enumerable: false,
        configurable: true
    });
    IgrDomainChart.prototype.ensureDataToolTipHeaderTextMargin = function () {
        if (this.i.vs) {
            return;
        }
        this.i.vs = new Thickness(2);
    };
    Object.defineProperty(IgrDomainChart.prototype, "dataToolTipHeaderRowMarginBottom", {
        get: function () {
            return this.i.vr ? this.i.vr.bottom : NaN;
        },
        set: function (v) {
            this.ensureDataToolTipHeaderRowMargin();
            this.i.vr.bottom = +v;
            this.i.vr = this.i.vr;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "dataToolTipHeaderRowMarginLeft", {
        get: function () {
            return this.i.vr ? this.i.vr.left : NaN;
        },
        set: function (v) {
            this.ensureDataToolTipHeaderRowMargin();
            this.i.vr.left = +v;
            this.i.vr = this.i.vr;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "dataToolTipHeaderRowMarginRight", {
        get: function () {
            return this.i.vr ? this.i.vr.right : NaN;
        },
        set: function (v) {
            this.ensureDataToolTipHeaderRowMargin();
            this.i.vr.right = +v;
            this.i.vr = this.i.vr;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "dataToolTipHeaderRowMarginTop", {
        get: function () {
            return this.i.vr ? this.i.vr.top : NaN;
        },
        set: function (v) {
            this.ensureDataToolTipHeaderRowMargin();
            this.i.vr.top = +v;
            this.i.vr = this.i.vr;
        },
        enumerable: false,
        configurable: true
    });
    IgrDomainChart.prototype.ensureDataToolTipHeaderRowMargin = function () {
        if (this.i.vr) {
            return;
        }
        this.i.vr = new Thickness(2);
    };
    Object.defineProperty(IgrDomainChart.prototype, "dataToolTipHeaderRowVisible", {
        /**
         * Gets or sets whether to show Header row.
        */
        get: function () {
            return this.i.fo;
        },
        set: function (v) {
            this.i.fo = ensureBool(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "dataToolTipHeaderTextStyle", {
        /**
         * Gets or Sets the style to use for the header text.
        */
        get: function () {
            if (this.i.ed == null) {
                return null;
            }
            return this.i.ed.fontString;
        },
        set: function (v) {
            var fi = new FontInfo();
            fi.fontString = v;
            this.i.ed = fi;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "dataToolTipSummaryTitleTextColor", {
        /**
         * Gets or sets the summary text color.
        */
        get: function () {
            return brushToString(this.i.ut);
        },
        set: function (v) {
            this.i.ut = stringToBrush(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "dataToolTipSummaryTitleTextStyle", {
        /**
         * Gets or Sets the style to use for the summary text.
        */
        get: function () {
            if (this.i.eg == null) {
                return null;
            }
            return this.i.eg.fontString;
        },
        set: function (v) {
            var fi = new FontInfo();
            fi.fontString = v;
            this.i.eg = fi;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "dataToolTipSummaryType", {
        /**
         * Gets or sets the SummaryType for the data legend.
        */
        get: function () {
            return this.i.bl;
        },
        set: function (v) {
            this.i.bl = ensureEnum(DataLegendSummaryType_$type, v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "dataToolTipSummaryTitleText", {
        /**
         * Gets or sets the SummaryTitleText for the data legend.
        */
        get: function () {
            return this.i.m5;
        },
        set: function (v) {
            this.i.m5 = v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "dataToolTipSummaryTitleTextMarginBottom", {
        get: function () {
            return this.i.vv ? this.i.vv.bottom : NaN;
        },
        set: function (v) {
            this.ensureDataToolTipSummaryTitleTextMargin();
            this.i.vv.bottom = +v;
            this.i.vv = this.i.vv;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "dataToolTipSummaryTitleTextMarginLeft", {
        get: function () {
            return this.i.vv ? this.i.vv.left : NaN;
        },
        set: function (v) {
            this.ensureDataToolTipSummaryTitleTextMargin();
            this.i.vv.left = +v;
            this.i.vv = this.i.vv;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "dataToolTipSummaryTitleTextMarginRight", {
        get: function () {
            return this.i.vv ? this.i.vv.right : NaN;
        },
        set: function (v) {
            this.ensureDataToolTipSummaryTitleTextMargin();
            this.i.vv.right = +v;
            this.i.vv = this.i.vv;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "dataToolTipSummaryTitleTextMarginTop", {
        get: function () {
            return this.i.vv ? this.i.vv.top : NaN;
        },
        set: function (v) {
            this.ensureDataToolTipSummaryTitleTextMargin();
            this.i.vv.top = +v;
            this.i.vv = this.i.vv;
        },
        enumerable: false,
        configurable: true
    });
    IgrDomainChart.prototype.ensureDataToolTipSummaryTitleTextMargin = function () {
        if (this.i.vv) {
            return;
        }
        this.i.vv = new Thickness(2);
    };
    Object.defineProperty(IgrDomainChart.prototype, "dataToolTipSummaryRowMarginBottom", {
        get: function () {
            return this.i.vu ? this.i.vu.bottom : NaN;
        },
        set: function (v) {
            this.ensureDataToolTipSummaryRowMargin();
            this.i.vu.bottom = +v;
            this.i.vu = this.i.vu;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "dataToolTipSummaryRowMarginLeft", {
        get: function () {
            return this.i.vu ? this.i.vu.left : NaN;
        },
        set: function (v) {
            this.ensureDataToolTipSummaryRowMargin();
            this.i.vu.left = +v;
            this.i.vu = this.i.vu;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "dataToolTipSummaryRowMarginRight", {
        get: function () {
            return this.i.vu ? this.i.vu.right : NaN;
        },
        set: function (v) {
            this.ensureDataToolTipSummaryRowMargin();
            this.i.vu.right = +v;
            this.i.vu = this.i.vu;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "dataToolTipSummaryRowMarginTop", {
        get: function () {
            return this.i.vu ? this.i.vu.top : NaN;
        },
        set: function (v) {
            this.ensureDataToolTipSummaryRowMargin();
            this.i.vu.top = +v;
            this.i.vu = this.i.vu;
        },
        enumerable: false,
        configurable: true
    });
    IgrDomainChart.prototype.ensureDataToolTipSummaryRowMargin = function () {
        if (this.i.vu) {
            return;
        }
        this.i.vu = new Thickness(2);
    };
    Object.defineProperty(IgrDomainChart.prototype, "dataToolTipSummaryValueTextColor", {
        /**
         * Gets or sets the units text color.
        */
        get: function () {
            return brushToString(this.i.uv);
        },
        set: function (v) {
            this.i.uv = stringToBrush(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "dataToolTipSummaryValueTextStyle", {
        /**
         * Gets or Sets the style to use for the units text.
        */
        get: function () {
            if (this.i.ei == null) {
                return null;
            }
            return this.i.ei.fontString;
        },
        set: function (v) {
            var fi = new FontInfo();
            fi.fontString = v;
            this.i.ei = fi;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "dataToolTipSummaryLabelText", {
        /**
         * Gets or sets the units text for the data legend.
        */
        get: function () {
            return this.i.m0;
        },
        set: function (v) {
            this.i.m0 = v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "dataToolTipSummaryLabelTextColor", {
        /**
         * Gets or sets the units text color.
        */
        get: function () {
            return brushToString(this.i.us);
        },
        set: function (v) {
            this.i.us = stringToBrush(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "dataToolTipSummaryLabelTextStyle", {
        /**
         * Gets or Sets the style to use for the units text.
        */
        get: function () {
            if (this.i.ef == null) {
                return null;
            }
            return this.i.ef.fontString;
        },
        set: function (v) {
            var fi = new FontInfo();
            fi.fontString = v;
            this.i.ef = fi;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "dataToolTipSummaryUnitsText", {
        /**
         * Gets or sets the units text for the data legend.
        */
        get: function () {
            return this.i.nb;
        },
        set: function (v) {
            this.i.nb = v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "dataToolTipSummaryUnitsTextColor", {
        /**
         * Gets or sets the units text color.
        */
        get: function () {
            return brushToString(this.i.uu);
        },
        set: function (v) {
            this.i.uu = stringToBrush(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "dataToolTipSummaryUnitsTextStyle", {
        /**
         * Gets or Sets the style to use for the units text.
        */
        get: function () {
            if (this.i.eh == null) {
                return null;
            }
            return this.i.eh.fontString;
        },
        set: function (v) {
            var fi = new FontInfo();
            fi.fontString = v;
            this.i.eh = fi;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "dataToolTipBadgeMarginBottom", {
        get: function () {
            return this.i.vq ? this.i.vq.bottom : NaN;
        },
        set: function (v) {
            this.ensureDataToolTipBadgeMargin();
            this.i.vq.bottom = +v;
            this.i.vq = this.i.vq;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "dataToolTipBadgeMarginLeft", {
        get: function () {
            return this.i.vq ? this.i.vq.left : NaN;
        },
        set: function (v) {
            this.ensureDataToolTipBadgeMargin();
            this.i.vq.left = +v;
            this.i.vq = this.i.vq;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "dataToolTipBadgeMarginRight", {
        get: function () {
            return this.i.vq ? this.i.vq.right : NaN;
        },
        set: function (v) {
            this.ensureDataToolTipBadgeMargin();
            this.i.vq.right = +v;
            this.i.vq = this.i.vq;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "dataToolTipBadgeMarginTop", {
        get: function () {
            return this.i.vq ? this.i.vq.top : NaN;
        },
        set: function (v) {
            this.ensureDataToolTipBadgeMargin();
            this.i.vq.top = +v;
            this.i.vq = this.i.vq;
        },
        enumerable: false,
        configurable: true
    });
    IgrDomainChart.prototype.ensureDataToolTipBadgeMargin = function () {
        if (this.i.vq) {
            return;
        }
        this.i.vq = new Thickness(2);
    };
    Object.defineProperty(IgrDomainChart.prototype, "dataToolTipBadgeShape", {
        /**
         * Gets or sets the BadgeShape for the data legend.
        */
        get: function () {
            return this.i.ch;
        },
        set: function (v) {
            this.i.ch = ensureEnum(LegendItemBadgeShape_$type, v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "dataToolTipUnitsDisplayMode", {
        /**
         * Gets or sets the UnitsMode for the data legend.
        */
        get: function () {
            return this.i.bn;
        },
        set: function (v) {
            this.i.bn = ensureEnum(DataLegendUnitsMode_$type, v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "dataToolTipUnitsText", {
        /**
         * Gets or sets the units text for the data legend.
        */
        get: function () {
            return this.i.nl;
        },
        set: function (v) {
            this.i.nl = v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "dataToolTipUnitsTextColor", {
        /**
         * Gets or sets the units text color.
        */
        get: function () {
            return brushToString(this.i.ux);
        },
        set: function (v) {
            this.i.ux = stringToBrush(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "dataToolTipUnitsTextMarginBottom", {
        get: function () {
            return this.i.vx ? this.i.vx.bottom : NaN;
        },
        set: function (v) {
            this.ensureDataToolTipUnitsTextMargin();
            this.i.vx.bottom = +v;
            this.i.vx = this.i.vx;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "dataToolTipUnitsTextMarginLeft", {
        get: function () {
            return this.i.vx ? this.i.vx.left : NaN;
        },
        set: function (v) {
            this.ensureDataToolTipUnitsTextMargin();
            this.i.vx.left = +v;
            this.i.vx = this.i.vx;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "dataToolTipUnitsTextMarginRight", {
        get: function () {
            return this.i.vx ? this.i.vx.right : NaN;
        },
        set: function (v) {
            this.ensureDataToolTipUnitsTextMargin();
            this.i.vx.right = +v;
            this.i.vx = this.i.vx;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "dataToolTipUnitsTextMarginTop", {
        get: function () {
            return this.i.vx ? this.i.vx.top : NaN;
        },
        set: function (v) {
            this.ensureDataToolTipUnitsTextMargin();
            this.i.vx.top = +v;
            this.i.vx = this.i.vx;
        },
        enumerable: false,
        configurable: true
    });
    IgrDomainChart.prototype.ensureDataToolTipUnitsTextMargin = function () {
        if (this.i.vx) {
            return;
        }
        this.i.vx = new Thickness(2);
    };
    Object.defineProperty(IgrDomainChart.prototype, "dataToolTipUnitsTextStyle", {
        /**
         * Gets or Sets the style to use for the units text.
        */
        get: function () {
            if (this.i.ek == null) {
                return null;
            }
            return this.i.ek.fontString;
        },
        set: function (v) {
            var fi = new FontInfo();
            fi.fontString = v;
            this.i.ek = fi;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "dataToolTipTitleTextMarginBottom", {
        get: function () {
            return this.i.vw ? this.i.vw.bottom : NaN;
        },
        set: function (v) {
            this.ensureDataToolTipTitleTextMargin();
            this.i.vw.bottom = +v;
            this.i.vw = this.i.vw;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "dataToolTipTitleTextMarginLeft", {
        get: function () {
            return this.i.vw ? this.i.vw.left : NaN;
        },
        set: function (v) {
            this.ensureDataToolTipTitleTextMargin();
            this.i.vw.left = +v;
            this.i.vw = this.i.vw;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "dataToolTipTitleTextMarginRight", {
        get: function () {
            return this.i.vw ? this.i.vw.right : NaN;
        },
        set: function (v) {
            this.ensureDataToolTipTitleTextMargin();
            this.i.vw.right = +v;
            this.i.vw = this.i.vw;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "dataToolTipTitleTextMarginTop", {
        get: function () {
            return this.i.vw ? this.i.vw.top : NaN;
        },
        set: function (v) {
            this.ensureDataToolTipTitleTextMargin();
            this.i.vw.top = +v;
            this.i.vw = this.i.vw;
        },
        enumerable: false,
        configurable: true
    });
    IgrDomainChart.prototype.ensureDataToolTipTitleTextMargin = function () {
        if (this.i.vw) {
            return;
        }
        this.i.vw = new Thickness(2);
    };
    Object.defineProperty(IgrDomainChart.prototype, "dataToolTipTitleTextColor", {
        /**
         * Gets or sets the display text color.
        */
        get: function () {
            return brushToString(this.i.uw);
        },
        set: function (v) {
            this.i.uw = stringToBrush(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "dataToolTipTitleTextStyle", {
        /**
         * Gets or Sets the style to use for the display text.
        */
        get: function () {
            if (this.i.ej == null) {
                return null;
            }
            return this.i.ej.fontString;
        },
        set: function (v) {
            var fi = new FontInfo();
            fi.fontString = v;
            this.i.ej = fi;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "dataToolTipLabelDisplayMode", {
        /**
         * Gets or sets the mode for displaying labels before series values in the data legend, e.g. O: H: L: C: for financial series
        */
        get: function () {
            return this.i.bj;
        },
        set: function (v) {
            this.i.bj = ensureEnum(DataLegendLabelMode_$type, v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "dataToolTipLabelTextColor", {
        /**
         * Gets or sets the units text color.
        */
        get: function () {
            return brushToString(this.i.ur);
        },
        set: function (v) {
            this.i.ur = stringToBrush(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "dataToolTipLabelTextMarginBottom", {
        get: function () {
            return this.i.vt ? this.i.vt.bottom : NaN;
        },
        set: function (v) {
            this.ensureDataToolTipLabelTextMargin();
            this.i.vt.bottom = +v;
            this.i.vt = this.i.vt;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "dataToolTipLabelTextMarginLeft", {
        get: function () {
            return this.i.vt ? this.i.vt.left : NaN;
        },
        set: function (v) {
            this.ensureDataToolTipLabelTextMargin();
            this.i.vt.left = +v;
            this.i.vt = this.i.vt;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "dataToolTipLabelTextMarginRight", {
        get: function () {
            return this.i.vt ? this.i.vt.right : NaN;
        },
        set: function (v) {
            this.ensureDataToolTipLabelTextMargin();
            this.i.vt.right = +v;
            this.i.vt = this.i.vt;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "dataToolTipLabelTextMarginTop", {
        get: function () {
            return this.i.vt ? this.i.vt.top : NaN;
        },
        set: function (v) {
            this.ensureDataToolTipLabelTextMargin();
            this.i.vt.top = +v;
            this.i.vt = this.i.vt;
        },
        enumerable: false,
        configurable: true
    });
    IgrDomainChart.prototype.ensureDataToolTipLabelTextMargin = function () {
        if (this.i.vt) {
            return;
        }
        this.i.vt = new Thickness(2);
    };
    Object.defineProperty(IgrDomainChart.prototype, "dataToolTipLabelTextStyle", {
        /**
         * Gets or Sets the style to use for the units text.
        */
        get: function () {
            if (this.i.ee == null) {
                return null;
            }
            return this.i.ee.fontString;
        },
        set: function (v) {
            var fi = new FontInfo();
            fi.fontString = v;
            this.i.ee = fi;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "domainType", {
        /**
         * Gets the domain type of this chart
        */
        get: function () {
            return this.i.b1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "sortDescriptions", {
        /**
         * Gets the current sort that is applied to the grid. Collection can be updated to modify the sort for the grid. Once sort descriptions are in this collection, the grid will no longer listen for changes on their properties.
        */
        get: function () {
            var r = this.i.a0;
            if (r == null) {
                return null;
            }
            if (!r.externalObject) {
                var e = new IgrChartSortDescriptionCollection();
                if (r.$type) {
                    e._implementation = r;
                }
                else {
                    if (e.i.setNativeElement) {
                        e.i.setNativeElement(r);
                    }
                }
                r.externalObject = e;
            }
            return r.externalObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "groupSortDescriptions", {
        get: function () {
            var r = this.i.aw;
            if (r == null) {
                return null;
            }
            if (!r.externalObject) {
                var e = new IgrChartSortDescriptionCollection();
                if (r.$type) {
                    e._implementation = r;
                }
                else {
                    if (e.i.setNativeElement) {
                        e.i.setNativeElement(r);
                    }
                }
                r.externalObject = e;
            }
            return r.externalObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "groupDescriptions", {
        /**
         * Gets the current grouping that is applied to the grid. Collection can be updated to modify the grouping for the grid. Once grouping descriptions are in this collection, the grid will no longer listen for changes on their properties.
        */
        get: function () {
            var r = this.i.av;
            if (r == null) {
                return null;
            }
            if (!r.externalObject) {
                var e = new IgrChartSortDescriptionCollection();
                if (r.$type) {
                    e._implementation = r;
                }
                else {
                    if (e.i.setNativeElement) {
                        e.i.setNativeElement(r);
                    }
                }
                r.externalObject = e;
            }
            return r.externalObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "filterExpressions", {
        /**
         * Gets the current filter that is applied to the grid. Collection can be updated to modify the filter for the grid. Once filter expresisons are in this collection, the grid will no longer listen for changes on their properties.
        */
        get: function () {
            var r = this.i.dz;
            if (r == null) {
                return null;
            }
            if (!r.externalObject) {
                var e = new IgrFilterExpressionCollection();
                if (r.$type) {
                    e._implementation = r;
                }
                else {
                    if (e.i.setNativeElement) {
                        e.i.setNativeElement(r);
                    }
                }
                r.externalObject = e;
            }
            return r.externalObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "summaryDescriptions", {
        /**
         * Gets the current summaries that are applied to the grid.
        */
        get: function () {
            var r = this.i.a4;
            if (r == null) {
                return null;
            }
            if (!r.externalObject) {
                var e = new IgrChartSummaryDescriptionCollection();
                if (r.$type) {
                    e._implementation = r;
                }
                else {
                    if (e.i.setNativeElement) {
                        e.i.setNativeElement(r);
                    }
                }
                r.externalObject = e;
            }
            return r.externalObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "initialSortDescriptions", {
        /**
         * Gets the initial sorts that are applied to the chart.
        */
        get: function () {
            var r = this.i.az;
            if (r == null) {
                return null;
            }
            if (!r.externalObject) {
                var e = new IgrChartSortDescriptionCollection();
                if (r.$type) {
                    e._implementation = r;
                }
                else {
                    if (e.i.setNativeElement) {
                        e.i.setNativeElement(r);
                    }
                }
                r.externalObject = e;
            }
            return r.externalObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "initialGroupSortDescriptions", {
        /**
         * Gets the initial sorts that are applied to the chart after groupings and summaries are applied.
        */
        get: function () {
            var r = this.i.ay;
            if (r == null) {
                return null;
            }
            if (!r.externalObject) {
                var e = new IgrChartSortDescriptionCollection();
                if (r.$type) {
                    e._implementation = r;
                }
                else {
                    if (e.i.setNativeElement) {
                        e.i.setNativeElement(r);
                    }
                }
                r.externalObject = e;
            }
            return r.externalObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "initialGroupDescriptions", {
        /**
         * Gets the initial groupings that are applied to the chart.
        */
        get: function () {
            var r = this.i.ax;
            if (r == null) {
                return null;
            }
            if (!r.externalObject) {
                var e = new IgrChartSortDescriptionCollection();
                if (r.$type) {
                    e._implementation = r;
                }
                else {
                    if (e.i.setNativeElement) {
                        e.i.setNativeElement(r);
                    }
                }
                r.externalObject = e;
            }
            return r.externalObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "initialSummaryDescriptions", {
        /**
         * Gets the initial summaries that are applied to the chart.
        */
        get: function () {
            var r = this.i.a3;
            if (r == null) {
                return null;
            }
            if (!r.externalObject) {
                var e = new IgrChartSummaryDescriptionCollection();
                if (r.$type) {
                    e._implementation = r;
                }
                else {
                    if (e.i.setNativeElement) {
                        e.i.setNativeElement(r);
                    }
                }
                r.externalObject = e;
            }
            return r.externalObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "initialSorts", {
        /**
         * Gets or sets the sorts to apply to the chart. This property will become ignored if sorts are changed outside of this property.
        */
        get: function () {
            return this.i.oz;
        },
        set: function (v) {
            this.i.oz = v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "groupSorts", {
        /**
         * Gets or sets the sorts to apply after grouping has been applied.
        */
        get: function () {
            return this.i.og;
        },
        set: function (v) {
            this.i.og = v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "initialGroups", {
        /**
         * Gets or sets the groupings to apply to the chart. This property will become ignored if sorts are changed outside of this property.
        */
        get: function () {
            return this.i.ox;
        },
        set: function (v) {
            this.i.ox = v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "initialSummaries", {
        /**
         * Gets or sets the summaries to apply to the chart. This property will become ignored if sorts are changed outside of this property.
        */
        get: function () {
            return this.i.o1;
        },
        set: function (v) {
            this.i.o1 = v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "includedProperties", {
        /**
         * Gets or sets a set of property paths that should be included for consideration by the category chart, leaving the remainder excluded. If null, all properties will be considered.
        *
        * The `IncludedProperties` property used to include the properties for the consideration of the category chart.
        *
        * ```ts
        * this.chart.includedProperties = ["ProductName", "Cost"];
        * ```
        *
        * ```ts
        * 	<IgrCategoryChart
        * 		chartType="Line"
        * 		markerTypes={this.state.markersTypes}
        * 		dataSource={this.categoryData}
        * 		excludedProperties="value" />
        * ```
        */
        get: function () {
            return this.i.q;
        },
        set: function (v) {
            if (v && !Array.isArray(v) && typeof (v) == "string") {
                var re = /\s*(?:,|\s|$)\s*/gm;
                v = v.split(re);
            }
            this.i.q = v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "excludedProperties", {
        /**
         * Gets or sets a set of property paths that should be excluded from consideration by the category chart.
        *
        * The `ExcludedProperties` property used for the property paths that should be excluded from consideration by the category chart.
        *
        * ```ts
        * this.chart.excludedProperties = ["ID", "Discount"];
        * ```
        *
        * ```ts
        * 	<IgrCategoryChart
        * 	chartType="Line"
        * 	markerTypes={this.state.markersTypes}
        * 	dataSource={this.categoryData}
        * 	excludedProperties="value" />
        * ```
        */
        get: function () {
            return this.i.o;
        },
        set: function (v) {
            if (v && !Array.isArray(v) && typeof (v) == "string") {
                var re = /\s*(?:,|\s|$)\s*/gm;
                v = v.split(re);
            }
            this.i.o = v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "brushes", {
        /**
         * Gets or sets the palette of brushes to use for coloring the chart series.
         * The value provided should be an array of CSS color strings or JavaScript objects defining gradients. Optionally the first element can be a string reading "RGB" or "HSV" to specify the interpolation mode of the collection
        *
        * Use the `Brushes` property to  set the brushes.
        *
        * ```ts
        * this.chart.brushes = ["#ff0000","#00ff00"];
        * ```
        */
        get: function () {
            return fromBrushCollection(this.i.ab);
        },
        set: function (v) {
            this.i.ab = toBrushCollection(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "outlines", {
        /**
         * Gets or sets the palette of brushes to use for outlines on the chart series.
         * The value provided should be an array of CSS color strings or JavaScript objects defining gradients. Optionally the first element can be a string reading "RGB" or "HSV" to specify the interpolation mode of the collection
        *
        *  Use the `Outlines` property to sets the palette of brushes to use for outlines on the chart series
        *
        * ```ts
        * <IgrCategoryChart
        * 	chartType="Line"
        * 	outlines= "#ff0000"
        * 	dataSource={this.categoryData}/>
        * ```
        */
        get: function () {
            return fromBrushCollection(this.i.af);
        },
        set: function (v) {
            this.i.af = toBrushCollection(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "actualBrushes", {
        /**
         * Gets the actual palette of brushes to use for coloring the chart series.
        */
        get: function () {
            return fromBrushCollection(this.i.z);
        },
        set: function (v) {
            this.i.z = toBrushCollection(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "actualOutlines", {
        /**
         * Gets the actual palette of brushes to use for outlines on the chart series.
        */
        get: function () {
            return fromBrushCollection(this.i.aa);
        },
        set: function (v) {
            this.i.aa = toBrushCollection(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "isHorizontalZoomEnabled", {
        /**
         * Gets or sets whether the chart can be horizontally zoomed through user interactions.
        *
        * Use the `IsHorizontalZoomEnabled` property to allow chart horizontally zoomed .
        *
        * ```ts
        *  <IgrCategoryChart dataSource={this.state.data}
        *                    width="700px"
        *                    height="500px"
        *                    xAxisLabelTextStyle="10pt Verdana"
        *                    xAxisLabelTopMargin={5}
        *                    xAxisLabelTextColor="gray"
        *                    yAxisLabelTextStyle="10pt Verdana"
        *                    yAxisLabelRightMargin={5}
        *                    yAxisLabelTextColor="gray"
        * 				   isHorizontalZoomEnabled= true/>
        * ```
        *
        * ```ts
        *  <IgrCategoryChart dataSource={this.state.data}
        *                    IsHorizontalZoomEnabled= true />
        * ```
        *
        * ```ts
        * this.chart.isHorizontalZoomEnabled = true;
        * ```
        */
        get: function () {
            return this.i.f2;
        },
        set: function (v) {
            this.i.f2 = ensureBool(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "isVerticalZoomEnabled", {
        /**
         * Gets or sets whether the chart can be vertically zoomed through user interactions.
        *
        * Use the `IsVerticalZoomEnabled` property to allow chart zoom vertically.
        *
        * ```ts
        *  this.chart.isVerticalZoomEnabled = true;
        * ```
        *
        * ```ts
        *  <IgrCategoryChart dataSource={this.state.data}
        *                   isVerticalZoomEnabled= "true"/>
        * ```
        */
        get: function () {
            return this.i.f9;
        },
        set: function (v) {
            this.i.f9 = ensureBool(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "shouldDisplayMockData", {
        /**
         * Gets or sets whether the chart should display mock data when the data source has not been provided, if supported for this type of chart.
        */
        get: function () {
            return this.i.gc;
        },
        set: function (v) {
            this.i.gc = ensureBool(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "shouldUseSkeletonStyleForMockData", {
        /**
         * Gets or sets whether the chart should use a faded skeleton style for mock data.
        */
        get: function () {
            return this.i.gf;
        },
        set: function (v) {
            this.i.gf = ensureBool(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "isSeriesHighlightingEnabled", {
        /**
         * Gets or sets whether the chart can highlight series through user interactions.
         * This property applies to Category Chart and Financial Chart controls.
        */
        get: function () {
            return this.i.f4;
        },
        set: function (v) {
            this.i.f4 = ensureBool(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "windowRect", {
        /**
         * Gets or sets the rectangle representing the current scroll and zoom state of the chart.
         * WindowRect is expressed as a Rectangle with coordinates and sizes between 0 and 1.
        *
        * Use `WindowRect` property representing the current scroll and zoom state of the chart.
        *
        * ```ts
        * this.chart.windowRect =[0,0,1,1];
        * ```
        *
        * ```ts
        * <IgrCategoryChart dataSource={this.state.data}
        *                WindowRect={1,0,1,1} />
        * ```
        */
        get: function () {
            return fromRect(this.i.vf);
        },
        set: function (v) {
            this.i.vf = toRect(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "viewport", {
        /**
         * Gets a rectangle representing the bounds of the plot area.
        *
        * `viewport` property representing the bounds of the plot area.
        *
        * ```ts
        * let viewport:Rect =  this.chart.viewport;
        * ```
        */
        get: function () {
            return fromRect(this.i.ve);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "chartTitle", {
        /**
         * Gets or sets text to display above the plot area.
        *
        * Use the `Title` property to display the text above the plot area.
        *
        * ```ts
        *  this.chart.title= "This is a Title";
        * ```
        *
        * ```ts
        *  <IgrCategoryChart
        * 	width="100%"
        * 	height="100%"
        * 	chartType="Line"
        * 	dataSource={this.categoryData}
        * 	title= "CategoryChart Subtitle"	/>
        * ```
        */
        get: function () {
            return this.i.qb;
        },
        set: function (v) {
            this.i.qb = v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "subtitle", {
        /**
         * Gets or sets text to display below the Title, above the plot area.
        *
        * Use the `Subtitle` property to display the text below  and above the plot area.
        *
        * ```ts
        *  <IgrCategoryChart
        * 	width="100%"
        * 	height="100%"
        * 	chartType="Line"
        * 	dataSource={this.categoryData}
        * 	subtitle= "CategoryChart Subtitle"/>
        * ```
        *
        * ```ts
        *  this.chart.subtitle ="CategoryChart Subtitle" ;
        * ```
        */
        get: function () {
            return this.i.p0;
        },
        set: function (v) {
            this.i.p0 = v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "titleAlignment", {
        /**
         * Gets or sets horizontal alignment which determines the title position, relative to the left and right edges of the control.
        *
        * Use the `TitleAlignment` property for the horizontal alignment of the title.
        *
        * ```ts
        * this.chart.titleAlignment = HorizontalAlignment.Center;
        * ```
        *
        * ```ts
        *  <IgrCategoryChart
        * 	width="100%"
        * 	height="100%"
        * 	chartType="Line"
        * 	dataSource={this.categoryData}
        * 	titleAlignment= "Center"/>
        * ```
        */
        get: function () {
            return this.i.tw;
        },
        set: function (v) {
            this.i.tw = ensureEnum(HorizontalAlignment_$type, v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "subtitleAlignment", {
        /**
         * Gets or sets horizontal alignment which determines the subtitle position, relative to the left and right edges of the control.
        *
        * Use the `SubtitleAlignment` property to Gets or sets horizontal alignment.
        *
        * ```ts
        *  <IgrCategoryChart
        * 	width="100%"
        * 	height="100%"
        * 	chartType="Line"
        * 	dataSource={this.categoryData}
        * 	subtitle= "CategoryChart Subtitle"
        * 	subtitleAlignment="Right"/>
        * ```
        *
        * ```ts
        * this.chart.subtitleAlignment = HorizontalAlignment.Right;
        * ```
        */
        get: function () {
            return this.i.tv;
        },
        set: function (v) {
            this.i.tv = ensureEnum(HorizontalAlignment_$type, v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "unknownValuePlotting", {
        /**
         * Gets or sets the behavior that determines how unknown values will be plotted on the chart.
         * Null and Double.NaN are two examples of unknown values.
        *
        * Use the `UnknownValuePlotting` property to determines the behavior that how unknown values will be plotted on the chart.
        *
        * ```ts
        * this.chart.unknownValuePlotting =UnknownValuePlotting.DontPlot;
        * ```
        *
        * ```ts
        * <IgrCategoryChart dataSource={this.state.data}
        *                unknownValuePlotting= "dontPlot" />
        * ```
        */
        get: function () {
            return this.i.ds;
        },
        set: function (v) {
            this.i.ds = ensureEnum(UnknownValuePlotting_$type, v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "resolution", {
        /**
         * Gets or sets the rendering resolution for all series in this chart.
         * Where n = Resolution, for every n horizontal pixels, combine all items into a single data point.  When Resolution = 0, all data points will be rendered as graphical objects.  Charts with a higher resolution will have faster performance.
        *
        * Use the `Resolution` property if the callouts should be display.
        *
        * ```ts
        *   this.chart.resolution = 2 ;
        * ```
        *
        * ```ts
        *  <IgrCategoryChart
        * 	width="100%"
        * 	height="100%"
        * 	chartType="Line"
        * 	markerTypes={this.state.markersTypes}
        * 	dataSource={this.categoryData}
        * 	calloutsVisible="true"
        * 	resolution= {2}/>
        * ```
        */
        get: function () {
            return this.i.iv;
        },
        set: function (v) {
            this.i.iv = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "thickness", {
        /**
         * Gets or sets the thickness for all series in this chart. Depending on the ChartType, this can be the main brush used, or just the outline.
        *
        * Use the `Thickness` property for the thickness of all the series in this chart.
        */
        get: function () {
            return this.i.i1;
        },
        set: function (v) {
            this.i.i1 = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "outlineMode", {
        /**
         * Gets or sets the OutlineMode for all series in this chart.
        */
        get: function () {
            return this.i.c9;
        },
        set: function (v) {
            this.i.c9 = ensureEnum(SeriesOutlineMode_$type, v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "markerOutlineMode", {
        /**
         * Gets or sets the MarkerOutlineMode for all series that support markers in this chart.
        */
        get: function () {
            return this.i.co;
        },
        set: function (v) {
            this.i.co = ensureEnum(MarkerOutlineMode_$type, v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "markerFillMode", {
        /**
         * Gets or sets the MarkerFillMode for all series that support markers in this chart.
        */
        get: function () {
            return this.i.cm;
        },
        set: function (v) {
            this.i.cm = ensureEnum(MarkerFillMode_$type, v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "markerFillOpacity", {
        /**
         * Gets or sets the Marker Fill Opacity for all series that support markers in this chart.
        */
        get: function () {
            return this.i.io;
        },
        set: function (v) {
            this.i.io = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "markerThickness", {
        /**
         * Gets or sets the Marker Thickness for all series that support markers in this chart.
        */
        get: function () {
            return this.i.ip;
        },
        set: function (v) {
            this.i.ip = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "markerTypes", {
        /**
         * Gets or sets the marker shapes used for indicating location of data points in this chart.
         * This property applies only to these chart types: point, line, spline, bubble, and polygon
        */
        get: function () {
            if (this._markerTypes === null) {
                var coll = new IgrMarkerTypeCollection();
                var innerColl = this.i.cu;
                if (!innerColl) {
                    innerColl = new MarkerTypeCollection_internal();
                }
                this._markerTypes = coll._fromInner(innerColl);
                this.i.cu = innerColl;
            }
            return this._markerTypes;
        },
        set: function (v) {
            if (this._markerTypes !== null) {
                this._markerTypes._setSyncTarget(null);
                this._markerTypes = null;
            }
            var coll = new IgrMarkerTypeCollection();
            this._markerTypes = coll._fromOuter(v);
            var syncColl = new SyncableObservableCollection$1(MarkerType_$type);
            var innerColl = this.i.cu;
            if (!innerColl) {
                innerColl = new MarkerTypeCollection_internal();
            }
            syncColl._inner = innerColl;
            syncColl.clear();
            this._markerTypes._setSyncTarget(syncColl);
            this.i.cu = innerColl;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "markerAutomaticBehavior", {
        /**
         * Gets or sets the default marker type for all series plotted in this chart.
         * This property is ignored when the MarkerTypes property is set
        */
        get: function () {
            return this.i.ck;
        },
        set: function (v) {
            this.i.ck = ensureEnum(MarkerAutomaticBehavior_$type, v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "markerBrushes", {
        /**
         * Gets or sets the palette of brushes used for rendering fill area of data point markers.
         * This property applies only to these chart types: point, line, spline, bubble, and polygon
        *
        * `MarkerBrushes` property used for rendering fill area of data point markers.
        *
        * ```ts
        *  this.chart.markerBrushes=[ "#ff0000", "#ffff00", "#00ffff" ];
        * ```
        *
        * ```ts
        * <IgrCategoryChart
        *     chartType="Line"
        *     markerBrushes ="#ffff00"
        *     dataSource={this.categoryData}/>
        * ```
        */
        get: function () {
            return fromBrushCollection(this.i.ad);
        },
        set: function (v) {
            this.i.ad = toBrushCollection(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "markerOutlines", {
        /**
         * Gets or sets the palette of brushes used for rendering outlines of data point markers.
         * This property applies only to these chart types: point, line, spline, bubble, and polygon
        *
        * `MarkerOutlines` property used for rendering outlines of data point markers.
        *
        * ```ts
        * this.chart.markerOutlines= ["#ff0000", "#ffff00", "#00ffff"] ;
        * ```
        *
        * ```ts
        * <IgrCategoryChart
        * 	chartType="Line"
        * 	markerOutlines= "#ff0000"
        * 	dataSource={this.categoryData}/>
        * ```
        */
        get: function () {
            return fromBrushCollection(this.i.ae);
        },
        set: function (v) {
            this.i.ae = toBrushCollection(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "markerMaxCount", {
        /**
         * Gets or sets the maximum number of markers displayed in the plot area of the chart.
        *
        * `markerMaxCount` property used to display maximum number of markers in the plot area of the chart.
        *
        * ```ts
        *  this.chart.markerMaxCount = 100 ;
        * ```
        *
        * ```ts
        * <IgrCategoryChart
        * 	chartType="Line"
        * 	markerMaxCount= {2}
        * 	dataSource={this.categoryData}/>
        * ```
        */
        get: function () {
            return this.i.j0;
        },
        set: function (v) {
            this.i.j0 = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "areaFillOpacity", {
        /**
         * Gets or sets the fill opacity for all series that have area visuals in this chart.
         * For example, Area, SplineArea, Column chart types
        */
        get: function () {
            return this.i.h7;
        },
        set: function (v) {
            this.i.h7 = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "animateSeriesWhenAxisRangeChanges", {
        /**
         * Gets or sets whether the series animations should be allowed when a range change has been detected on an axis.
        */
        get: function () {
            return this.i.fh;
        },
        set: function (v) {
            this.i.fh = ensureBool(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "trendLineBrushes", {
        /**
         * Gets or sets the palette of brushes to used for coloring trend lines in this chart.
         * The value provided should be an array of CSS color strings or JavaScript objects defining gradients. Optionally the first element can be a string reading "RGB" or "HSV" to specify the interpolation mode of the collection
        *
        * Use the `TrendLineBrushes` property for coloring trend lines in the chart.
        *
        * ```ts
        * this.chart.trendLineBrushes=["#ff0000", "#ffff00", "#00ffff"]	;
        * ```
        *
        * ```ts
        * <IgrCategoryChart dataSource={this.state.data}
        *                trendLineBrushes="#ffff00" />
        * ```
        */
        get: function () {
            return fromBrushCollection(this.i.ah);
        },
        set: function (v) {
            this.i.ah = toBrushCollection(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "trendLineType", {
        /**
         * Gets or sets the formula used for calculating trend lines in this chart.
         * This property applies only to these chart types: point, line, spline, and bubble
        *
        * Use the `TrendLineType` property for calculating trend lines.
        *
        * ```ts
        * this.chart.trendLineType = TrendLineType.CubicFit;
        * ```
        *
        * ```ts
        * <IgrCategoryChart dataSource={this.state.data}
        *                trendLineType="CubicFit" />
        * ```
        */
        get: function () {
            return this.i.dq;
        },
        set: function (v) {
            this.i.dq = ensureEnum(TrendLineType_$type, v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "trendLineThickness", {
        /**
         * Gets or sets the thickness of the trend lines in this chart.
         * This property applies only to these chart types: point, line, spline, and bubble
        *
        * Use the `TrendLineThickness` property for the thickness of the trend lines in the chart.
        *
        * ```ts
        * this.chart.trendLineThickness=2;
        * ```
        *
        * ```ts
        * <IgrCategoryChart dataSource={this.state.data}
        *                trendLineThickness={2} />
        * ```
        */
        get: function () {
            return this.i.i7;
        },
        set: function (v) {
            this.i.i7 = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "alignsGridLinesToPixels", {
        /**
         * Gets or sets a value indicating whether grid and tick lines are aligned to device pixels.
        *
        * Use `AlignsGridLinesToPixels` propert to indicat whether grid and tick lines are aligned to device pixels.
        *
        * ```ts
        *  this.chart.alignsGridLinesToPixels= true;
        * ```
        */
        get: function () {
            return this.i.fg;
        },
        set: function (v) {
            this.i.fg = ensureBool(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "plotAreaMarginLeft", {
        /**
         * Margin applied to the Left of the plot area.
        */
        get: function () {
            return this.i.is;
        },
        set: function (v) {
            this.i.is = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "plotAreaMarginTop", {
        /**
         * Margin applied to the Top of the plot area.
        */
        get: function () {
            return this.i.iu;
        },
        set: function (v) {
            this.i.iu = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "plotAreaMarginRight", {
        /**
         * Margin applied to the right of the plot area.
        */
        get: function () {
            return this.i.it;
        },
        set: function (v) {
            this.i.it = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "plotAreaMarginBottom", {
        /**
         * Margin applied below the plot area.
        */
        get: function () {
            return this.i.ir;
        },
        set: function (v) {
            this.i.ir = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "computedPlotAreaMarginMode", {
        /**
         * Gets or sets mode to use for automatically calculating the plot area margin.
        */
        get: function () {
            return this.i.a6;
        },
        set: function (v) {
            this.i.a6 = ensureEnum(ComputedPlotAreaMarginMode_$type, v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "seriesPlotAreaMarginHorizontalMode", {
        /**
         * Gets or sets horizontal mode to use for automatically calculating the plot area margin based ont the series.
        */
        get: function () {
            return this.i.db;
        },
        set: function (v) {
            this.i.db = ensureEnum(SeriesPlotAreaMarginHorizontalMode_$type, v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "seriesPlotAreaMarginVerticalMode", {
        /**
         * Gets or sets vertical mode to use for automatically calculating the plot area margin based ont the series.
        */
        get: function () {
            return this.i.dd;
        },
        set: function (v) {
            this.i.dd = ensureEnum(SeriesPlotAreaMarginVerticalMode_$type, v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "highlightingMode", {
        /**
         * Gets or sets the highlighting mode to use for the series in the component, when supported. This takes precedence over the series level IsHightlightingEnabled.
        */
        get: function () {
            return this.i.c7;
        },
        set: function (v) {
            this.i.c7 = ensureEnum(SeriesHighlightingMode_$type, v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "highlightingBehavior", {
        /**
         * Gets or sets the highlighting Behavior to use for the series in the component, when supported. This takes precedence over the series level IsHightlightingEnabled.
        */
        get: function () {
            return this.i.c5;
        },
        set: function (v) {
            this.i.c5 = ensureEnum(SeriesHighlightingBehavior_$type, v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "legendHighlightingMode", {
        /**
         * Gets or sets the highlighting mode to use for the legend linked to the component, when supported.
        */
        get: function () {
            return this.i.cc;
        },
        set: function (v) {
            this.i.cc = ensureEnum(LegendHighlightingMode_$type, v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "legendItemBadgeShape", {
        /**
         * Gets or sets the type of legend badges representing all series displayed in a legend linked to this component
         * This property will be ignored when the LegendItemTemplate or LegendItemBadgeTemplate property is set on a series
        */
        get: function () {
            return this.i.ci;
        },
        set: function (v) {
            this.i.ci = ensureEnum(LegendItemBadgeShape_$type, v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "legendItemBadgeMode", {
        /**
         * Gets or sets the mode of legend badges representing all series displayed in a legend linked to this component.
         * This property will be ignored when the LegendItemTemplate or LegendItemBadgeTemplate property is set on a series
        */
        get: function () {
            return this.i.ce;
        },
        set: function (v) {
            this.i.ce = ensureEnum(LegendItemBadgeMode_$type, v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "trendLinePeriod", {
        get: function () {
            return this.i.j2;
        },
        set: function (v) {
            this.i.j2 = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "toolTipType", {
        /**
         * Gets or sets the style of tooltip to be displayed.
        */
        get: function () {
            return this.i.dn;
        },
        set: function (v) {
            this.i.dn = ensureEnum(ToolTipType_$type, v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "crosshairsDisplayMode", {
        /**
         * Gets or sets the crosshairs to be displayed.
        */
        get: function () {
            return this.i.a9;
        },
        set: function (v) {
            this.i.a9 = ensureEnum(CrosshairsDisplayMode_$type, v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "crosshairsSnapToData", {
        /**
         * Gets or sets whether crosshairs will snap to the nearest data point.
        */
        get: function () {
            return this.i.fn;
        },
        set: function (v) {
            this.i.fn = ensureBool(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "crosshairsLineVerticalStroke", {
        /**
         * Gets or sets the color to apply to vertical crosshairs line.
        */
        get: function () {
            return brushToString(this.i.up);
        },
        set: function (v) {
            this.i.up = stringToBrush(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "crosshairsLineThickness", {
        /**
         * Gets or sets thickness of crosshairs lines.
        */
        get: function () {
            return this.i.h9;
        },
        set: function (v) {
            this.i.h9 = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "crosshairsLineHorizontalStroke", {
        /**
         * Gets or sets the color to apply to horizontal crosshairs line.
        */
        get: function () {
            return brushToString(this.i.uo);
        },
        set: function (v) {
            this.i.uo = stringToBrush(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "crosshairsAnnotationEnabled", {
        /**
         * Gets or sets whether annotations are shown along the axis for crosshair values
        */
        get: function () {
            return this.i.fm;
        },
        set: function (v) {
            this.i.fm = ensureBool(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "crosshairsAnnotationXAxisBackground", {
        /**
         * Gets or sets the background of crosshair annotation on x-axis.
        */
        get: function () {
            return brushToString(this.i.uk);
        },
        set: function (v) {
            this.i.uk = stringToBrush(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "crosshairsAnnotationYAxisBackground", {
        /**
         * Gets or sets the background of crosshair annotation on y-axis.
        */
        get: function () {
            return brushToString(this.i.um);
        },
        set: function (v) {
            this.i.um = stringToBrush(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "crosshairsAnnotationXAxisTextColor", {
        /**
         * Gets or sets the text color of crosshair annotation on x-axis.
        */
        get: function () {
            return brushToString(this.i.ul);
        },
        set: function (v) {
            this.i.ul = stringToBrush(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "crosshairsAnnotationYAxisTextColor", {
        /**
         * Gets or sets the text color of crosshair annotation on y-axis.
        */
        get: function () {
            return brushToString(this.i.un);
        },
        set: function (v) {
            this.i.un = stringToBrush(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "crosshairsAnnotationXAxisPrecision", {
        /**
         * Gets or sets precision on interpolated values of crosshairs on x-axis.
        */
        get: function () {
            return this.i.jv;
        },
        set: function (v) {
            this.i.jv = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "crosshairsAnnotationYAxisPrecision", {
        /**
         * Gets or sets precision on interpolated values of crosshairs on y-axis.
        */
        get: function () {
            return this.i.jw;
        },
        set: function (v) {
            this.i.jw = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "shouldAvoidAxisAnnotationCollisions", {
        /**
         * Gets or sets whether annotations for the final value of each series is displayed on the axis.
        */
        get: function () {
            return this.i.gb;
        },
        set: function (v) {
            this.i.gb = ensureBool(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "shouldPanOnMaximumZoom", {
        /**
         * Gets or sets a whether the chart should pan its content when zooing in passed max zoom level.
        */
        get: function () {
            return this.i.gd;
        },
        set: function (v) {
            this.i.gd = ensureBool(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "finalValueAnnotationsVisible", {
        /**
         * Gets or sets whether annotations for the final value of each series is displayed on the axis.
        */
        get: function () {
            return this.i.ft;
        },
        set: function (v) {
            this.i.ft = ensureBool(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "finalValueAnnotationsBackground", {
        /**
         * Gets or sets the background of final value annotation.
        */
        get: function () {
            return brushToString(this.i.uz);
        },
        set: function (v) {
            this.i.uz = stringToBrush(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "finalValueAnnotationsTextColor", {
        /**
         * Gets or sets the text color of final value annotation.
        */
        get: function () {
            return brushToString(this.i.u0);
        },
        set: function (v) {
            this.i.u0 = stringToBrush(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "finalValueAnnotationsPrecision", {
        /**
         * Gets or sets precision on final value annotation.
        */
        get: function () {
            return this.i.jz;
        },
        set: function (v) {
            this.i.jz = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "autoCalloutsVisible", {
        /**
         * Gets or sets if the auto value callouts should be displayed.
        */
        get: function () {
            return this.i.fj;
        },
        set: function (v) {
            this.i.fj = ensureBool(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "calloutsVisible", {
        /**
         * Gets or sets if callouts should be displayed.
        */
        get: function () {
            return this.i.fl;
        },
        set: function (v) {
            this.i.fl = ensureBool(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "calloutStyleUpdatingEventEnabled", {
        /**
         * Gets or sets if event annotations should be displayed.
        */
        get: function () {
            return this.i.fk;
        },
        set: function (v) {
            this.i.fk = ensureBool(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "calloutsAllowedPositions", {
        /**
         * Gets or sets the allowed positions that the callout layer is allowed to use.
        */
        get: function () {
            if (this._calloutsAllowedPositions === null) {
                var coll = new IgrCalloutPlacementPositionsCollection();
                var innerColl = this.i.ak;
                if (!innerColl) {
                    innerColl = new CalloutPlacementPositionsCollection_internal();
                }
                this._calloutsAllowedPositions = coll._fromInner(innerColl);
                this.i.ak = innerColl;
            }
            return this._calloutsAllowedPositions;
        },
        set: function (v) {
            if (this._calloutsAllowedPositions !== null) {
                this._calloutsAllowedPositions._setSyncTarget(null);
                this._calloutsAllowedPositions = null;
            }
            var coll = new IgrCalloutPlacementPositionsCollection();
            this._calloutsAllowedPositions = coll._fromOuter(v);
            var syncColl = new SyncableObservableCollection$1(CalloutPlacementPositions_$type);
            var innerColl = this.i.ak;
            if (!innerColl) {
                innerColl = new CalloutPlacementPositionsCollection_internal();
            }
            syncColl._inner = innerColl;
            syncColl.clear();
            this._calloutsAllowedPositions._setSyncTarget(syncColl);
            this.i.ak = innerColl;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "calloutsXMemberPath", {
        /**
         * Gets or sets the member path of the X data for the callouts.
        */
        get: function () {
            return this.i.lm;
        },
        set: function (v) {
            this.i.lm = v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "calloutsYMemberPath", {
        /**
         * Gets or sets the member path of the Y data for the callouts.
        */
        get: function () {
            return this.i.lo;
        },
        set: function (v) {
            this.i.lo = v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "calloutsLabelMemberPath", {
        /**
         * Gets or sets the member path of the label data for the callouts.
        */
        get: function () {
            return this.i.li;
        },
        set: function (v) {
            this.i.li = v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "calloutsContentMemberPath", {
        /**
         * Gets or sets the member path of the content data for the callouts.
        */
        get: function () {
            return this.i.lf;
        },
        set: function (v) {
            this.i.lf = v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "valueLines", {
        /**
         * Gets or sets what value lines to use in the chart.
        */
        get: function () {
            if (this._valueLines === null) {
                var coll = new IgrValueModeCollection();
                var innerColl = this.i.du;
                if (!innerColl) {
                    innerColl = new ValueModeCollection_internal();
                }
                this._valueLines = coll._fromInner(innerColl);
                this.i.du = innerColl;
            }
            return this._valueLines;
        },
        set: function (v) {
            if (this._valueLines !== null) {
                this._valueLines._setSyncTarget(null);
                this._valueLines = null;
            }
            var coll = new IgrValueModeCollection();
            this._valueLines = coll._fromOuter(v);
            var syncColl = new SyncableObservableCollection$1(ValueLayerValueMode_$type);
            var innerColl = this.i.du;
            if (!innerColl) {
                innerColl = new ValueModeCollection_internal();
            }
            syncColl._inner = innerColl;
            syncColl.clear();
            this._valueLines._setSyncTarget(syncColl);
            this.i.du = innerColl;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "valueLinesBrushes", {
        /**
         * Gets or sets the palette of brushes to use for coloring the value lines present in the ValueLines property.
         * The value provided should be an array of CSS color strings or JavaScript objects defining gradients. Optionally the first element can be a string reading "RGB" or "HSV" to specify the interpolation mode of the collection
        */
        get: function () {
            return fromBrushCollection(this.i.ai);
        },
        set: function (v) {
            this.i.ai = toBrushCollection(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "valueLinesThickness", {
        /**
         * Gets or sets thickness of value lines.
        */
        get: function () {
            return this.i.i8;
        },
        set: function (v) {
            this.i.i8 = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "horizontalViewScrollbarMode", {
        /**
         * Gets or sets the horizontal scrollbar mode to use for the series viewer.
        */
        get: function () {
            return this.i.di;
        },
        set: function (v) {
            this.i.di = ensureEnum(SeriesViewerScrollbarMode_$type, v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "verticalViewScrollbarMode", {
        /**
         * Gets or sets the vertical scrollbar mode to use for the series viewer.
        */
        get: function () {
            return this.i.dj;
        },
        set: function (v) {
            this.i.dj = ensureEnum(SeriesViewerScrollbarMode_$type, v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "horizontalViewScrollbarPosition", {
        /**
         * Gets or sets the position to use for the horizontal scrollbar in the component, when enabled.
        */
        get: function () {
            return this.i.df;
        },
        set: function (v) {
            this.i.df = ensureEnum(SeriesViewerHorizontalScrollbarPosition_$type, v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "verticalViewScrollbarPosition", {
        /**
         * Gets or sets the position to use for the vertical scrollbar in the component, when enabled.
        */
        get: function () {
            return this.i.dl;
        },
        set: function (v) {
            this.i.dl = ensureEnum(SeriesViewerVerticalScrollbarPosition_$type, v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "horizontalViewScrollbarFill", {
        /**
         * Gets or sets the fill to use for the horizontal scrollbar in the component, when enabled.
        */
        get: function () {
            return brushToString(this.i.u5);
        },
        set: function (v) {
            this.i.u5 = stringToBrush(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "horizontalViewScrollbarOutline", {
        /**
         * Gets or sets the outline to use for the horizontal scrollbar in the component, when enabled.
        */
        get: function () {
            return brushToString(this.i.u6);
        },
        set: function (v) {
            this.i.u6 = stringToBrush(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "horizontalViewScrollbarStrokeThickness", {
        /**
         * Gets or sets the stroke thickness to use for the horizontal scrollbar in the component, when enabled.
        */
        get: function () {
            return this.i.ij;
        },
        set: function (v) {
            this.i.ij = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "horizontalViewScrollbarMaxOpacity", {
        /**
         * Gets or sets the max opacity to use for the horizontal scrollbar in the component, when enabled.
        */
        get: function () {
            return this.i.ii;
        },
        set: function (v) {
            this.i.ii = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "horizontalViewScrollbarCornerRadius", {
        /**
         * Gets or sets the corner radius to use for the horizontal scrollbar in the component, when enabled.
        */
        get: function () {
            return this.i.ie;
        },
        set: function (v) {
            this.i.ie = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "horizontalViewScrollbarHeight", {
        /**
         * Gets or sets the height to use for the horizontal scrollbar in the component, when enabled.
        */
        get: function () {
            return this.i.ig;
        },
        set: function (v) {
            this.i.ig = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "horizontalViewScrollbarInset", {
        /**
         * Gets or sets the inset distance to use for the horizontal scrollbar in the component, when enabled.
        */
        get: function () {
            return this.i.ih;
        },
        set: function (v) {
            this.i.ih = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "horizontalViewScrollbarTrackStartInset", {
        /**
         * Gets or sets the track start inset to use for the horizontal scrollbar in the component, when enabled.
        */
        get: function () {
            return this.i.il;
        },
        set: function (v) {
            this.i.il = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "horizontalViewScrollbarTrackEndInset", {
        /**
         * Gets or sets the track end inset to use for the horizontal scrollbar in the component, when enabled.
        */
        get: function () {
            return this.i.ik;
        },
        set: function (v) {
            this.i.ik = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "horizontalViewScrollbarShouldAddAutoTrackInsets", {
        /**
         * Gets or sets whether to use automatic track insets for the horizontal scrollbar in the component, when enabled.
        */
        get: function () {
            return this.i.fv;
        },
        set: function (v) {
            this.i.fv = ensureBool(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "verticalViewScrollbarFill", {
        /**
         * Gets or sets the fill to use for the vertical scrollbar in the component, when enabled.
        */
        get: function () {
            return brushToString(this.i.va);
        },
        set: function (v) {
            this.i.va = stringToBrush(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "verticalViewScrollbarOutline", {
        /**
         * Gets or sets the outline to use for the vertical scrollbar in the component, when enabled.
        */
        get: function () {
            return brushToString(this.i.vb);
        },
        set: function (v) {
            this.i.vb = stringToBrush(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "verticalViewScrollbarStrokeThickness", {
        /**
         * Gets or sets the stroke thickness to use for the vertical scrollbar in the component, when enabled.
        */
        get: function () {
            return this.i.jc;
        },
        set: function (v) {
            this.i.jc = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "verticalViewScrollbarMaxOpacity", {
        /**
         * Gets or sets the max opacity to use for the vertical scrollbar in the component, when enabled.
        */
        get: function () {
            return this.i.jb;
        },
        set: function (v) {
            this.i.jb = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "verticalViewScrollbarCornerRadius", {
        /**
         * Gets or sets the corner radius to use for the vertical scrollbar in the component, when enabled.
        */
        get: function () {
            return this.i.i9;
        },
        set: function (v) {
            this.i.i9 = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "verticalViewScrollbarWidth", {
        /**
         * Gets or sets the width to use for the vertical scrollbar in the component, when enabled.
        */
        get: function () {
            return this.i.jf;
        },
        set: function (v) {
            this.i.jf = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "verticalViewScrollbarInset", {
        /**
         * Gets or sets the inset distance to use for the vertical scrollbar in the component, when enabled.
        */
        get: function () {
            return this.i.ja;
        },
        set: function (v) {
            this.i.ja = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "verticalViewScrollbarTrackStartInset", {
        /**
         * Gets or sets the track start inset to use for the vertical scrollbar in the component, when enabled.
        */
        get: function () {
            return this.i.je;
        },
        set: function (v) {
            this.i.je = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "verticalViewScrollbarTrackEndInset", {
        /**
         * Gets or sets the track end inset to use for the vertical scrollbar in the component, when enabled.
        */
        get: function () {
            return this.i.jd;
        },
        set: function (v) {
            this.i.jd = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "verticalViewScrollbarShouldAddAutoTrackInsets", {
        /**
         * Gets or sets whether to use automatic track insets for the vertical scrollbar in the component, when enabled.
        */
        get: function () {
            return this.i.gg;
        },
        set: function (v) {
            this.i.gg = ensureBool(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "windowRectMinWidth", {
        /**
         * Sets or gets the minimum width that the window rect is allowed to reach before being clamped.
         * Decrease this value if you want to allow for further zooming into the viewer.
         * If this value is lowered too much it can cause graphical corruption due to floating point arithmetic inaccuracy.
         * This property accepts values between 0.0 (max zooming) and 1.0 (no zooming)
        */
        get: function () {
            return this.i.jh;
        },
        set: function (v) {
            this.i.jh = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "windowRectMinHeight", {
        /**
         * Sets or gets the minimum height that the window rect is allowed to reach before being clamped.
         * Decrease this value if you want to allow for further zooming into the viewer.
         * If this value is lowered too much it can cause graphical corruption due to floating point arithmetic inaccuracy.
         * This property accepts values between 0.0 (max zooming) and 1.0 (no zooming)
        */
        get: function () {
            return this.i.jg;
        },
        set: function (v) {
            this.i.jg = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "windowSizeMinWidth", {
        /**
         * Sets or gets minimum pixel width that the window is allowed to reach before being clamped.
         * Decrease this value if you want to allow for further zooming into the viewer.
         * If this value is lowered too much it can cause graphical corruption due to floating point arithmetic inaccuracy.
         * This property is overridden by the WindowRectMinWidth property
        */
        get: function () {
            return this.i.jj;
        },
        set: function (v) {
            this.i.jj = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "windowSizeMinHeight", {
        /**
         * Sets or gets minimum pixel height that the window is allowed to reach before being clamped.
         * Decrease this value if you want to allow for further zooming into the viewer.
         * If this value is lowered too much it can cause graphical corruption due to floating point arithmetic inaccuracy.
         * This property is overridden by the WindowRectMinHeight property
        */
        get: function () {
            return this.i.ji;
        },
        set: function (v) {
            this.i.ji = +v;
        },
        enumerable: false,
        configurable: true
    });
    IgrDomainChart.prototype.findByName = function (name) {
        if (this.findEphemera) {
            if (name && name.indexOf("@@e:") == 0) {
                return this.findEphemera(name);
            }
        }
        if (this.dataToolTipValueFormatSpecifiers != null && arrayFindByName(this.dataToolTipValueFormatSpecifiers, name)) {
            return arrayFindByName(this.dataToolTipValueFormatSpecifiers, name);
        }
        if (this.dataToolTipHeaderFormatSpecifiers != null && arrayFindByName(this.dataToolTipHeaderFormatSpecifiers, name)) {
            return arrayFindByName(this.dataToolTipHeaderFormatSpecifiers, name);
        }
        if (this.sortDescriptions != null && this.sortDescriptions.findByName && this.sortDescriptions.findByName(name)) {
            return this.sortDescriptions.findByName(name);
        }
        if (this.groupSortDescriptions != null && this.groupSortDescriptions.findByName && this.groupSortDescriptions.findByName(name)) {
            return this.groupSortDescriptions.findByName(name);
        }
        if (this.groupDescriptions != null && this.groupDescriptions.findByName && this.groupDescriptions.findByName(name)) {
            return this.groupDescriptions.findByName(name);
        }
        if (this.filterExpressions != null && this.filterExpressions.findByName && this.filterExpressions.findByName(name)) {
            return this.filterExpressions.findByName(name);
        }
        if (this.summaryDescriptions != null && this.summaryDescriptions.findByName && this.summaryDescriptions.findByName(name)) {
            return this.summaryDescriptions.findByName(name);
        }
        if (this.initialSortDescriptions != null && this.initialSortDescriptions.findByName && this.initialSortDescriptions.findByName(name)) {
            return this.initialSortDescriptions.findByName(name);
        }
        if (this.initialGroupSortDescriptions != null && this.initialGroupSortDescriptions.findByName && this.initialGroupSortDescriptions.findByName(name)) {
            return this.initialGroupSortDescriptions.findByName(name);
        }
        if (this.initialGroupDescriptions != null && this.initialGroupDescriptions.findByName && this.initialGroupDescriptions.findByName(name)) {
            return this.initialGroupDescriptions.findByName(name);
        }
        if (this.initialSummaryDescriptions != null && this.initialSummaryDescriptions.findByName && this.initialSummaryDescriptions.findByName(name)) {
            return this.initialSummaryDescriptions.findByName(name);
        }
        if (this.legend && this.legend.name && this.legend.name == name) {
            return this.legend;
        }
        if (this.markerTypes != null && this.markerTypes.findByName && this.markerTypes.findByName(name)) {
            return this.markerTypes.findByName(name);
        }
        if (this.calloutsAllowedPositions != null && this.calloutsAllowedPositions.findByName && this.calloutsAllowedPositions.findByName(name)) {
            return this.calloutsAllowedPositions.findByName(name);
        }
        if (this.valueLines != null && this.valueLines.findByName && this.valueLines.findByName(name)) {
            return this.valueLines.findByName(name);
        }
        return null;
    };
    Object.defineProperty(IgrDomainChart.prototype, "hasUserValues", {
        get: function () {
            return this._hasUserValues;
        },
        enumerable: false,
        configurable: true
    });
    IgrDomainChart.prototype.__m = function (propertyName) {
        if (!this._inStyling) {
            this._hasUserValues.add(propertyName);
        }
    };
    IgrDomainChart.prototype._styling = function (container, component, parent) {
        if (this._inStyling) {
            return;
        }
        this._inStyling = true;
        this._stylingContainer = container;
        this._stylingParent = component;
        var genericPrefix = "";
        var typeName = this.i.$type.name;
        if (typeName.indexOf("Xam") === 0) {
            typeName = typeName.substring(3);
        }
        genericPrefix = toSpinal("DomainChart");
        var additionalPrefixes = [];
        var prefix = toSpinal(typeName);
        additionalPrefixes.push(prefix + "-");
        var b = this.i.$type.baseType;
        while (b && b.name != "Object" &&
            b.name != "Base" &&
            b.name != "Control" &&
            b.Name != "DependencyObject" &&
            b.Name != "FrameworkElement") {
            typeName = b.name;
            if (typeName.indexOf("Xam") === 0) {
                typeName = typeName.substring(3);
            }
            var basePrefix = toSpinal(typeName);
            additionalPrefixes.push(basePrefix + "-");
            b = b.baseType;
        }
        if (parent) {
            var parentTypeName = parent.i.$type.name;
            if (parentTypeName.indexOf("Xam") === 0) {
                parentTypeName = parentTypeName.substring(3);
            }
            var parentPrefix = toSpinal(parentTypeName);
            additionalPrefixes.push(parentPrefix + "-" + genericPrefix + "-");
            additionalPrefixes.push(parentPrefix + "-" + prefix + "-");
        }
        initializePropertiesFromCss(container, this, genericPrefix + "-", this.hasUserValues, false, additionalPrefixes);
        if (this._otherStyling) {
            this._otherStyling(container, component, parent);
        }
        this._inStyling = false;
    };
    /**
 * Provides a container for this control

*
* `provideContainer` method provide container for the control.
*
* ```ts
*     this.chart.provideContainer("Container");
* ```
*/
    IgrDomainChart.prototype.provideContainer = function (container) {
        this.i.provideContainer(container);
    };
    /**
     * Destroy this control
    
    *
    * Use the `destroy` property to destroy the chart.
    *
    * ```ts
    * this.chart.destroy();
    * ```
    */
    IgrDomainChart.prototype.destroy = function () {
        this.i.destroy();
    };
    /**
     * Called when the control has been resized.
    
    *
    * `NotifyResized` method Called when the control has been resized.
    *
    * ```ts
    * this.chart.notifyResized();
    * ```
    */
    IgrDomainChart.prototype.notifyResized = function () {
        this.i.notifyResized();
    };
    IgrDomainChart.prototype.notifyVisualPropertiesChanged = function () {
        this.i.sm();
    };
    /**
     * Forces any pending refresh to the chart to be finished.
    
    *
    * Method `flush` used to Forces any pending deferred work to render on the chart before continuing.
    *
    * ```ts
    * this.chart.flush();
    * ```
    */
    IgrDomainChart.prototype.flush = function () {
        this.i.rs();
    };
    /**
     * Hides the active main tooltip, if displayed.
    
    *
    * Use the `HideToolTip` method to hide the active tooltip.
    *
    * ```ts
    * this.chart.hideToolTip();
    * ```
    */
    IgrDomainChart.prototype.hideToolTip = function () {
        this.i.r0();
    };
    /**
     * Replays transition-in animation on all series in the chart.
    
    */
    IgrDomainChart.prototype.replayTransitionIn = function () {
        this.i.tf();
    };
    /**
     * Performs zoom in action on the chart by specified percentage of current window rect
    
    */
    IgrDomainChart.prototype.zoomIn = function (percentage) {
        this.i.tr(percentage);
    };
    /**
     * Performs zoom out action on the chart by specified percentage of current window rect
    
    */
    IgrDomainChart.prototype.zoomOut = function (percentage) {
        this.i.ts(percentage);
    };
    /**
     * Resets the zoom level to default.
    
    */
    IgrDomainChart.prototype.resetZoom = function () {
        this.i.tn();
    };
    IgrDomainChart.prototype.getDesiredToolbarActions = function () {
        var iv = this.i.getDesiredToolbarActions();
        return (iv);
    };
    IgrDomainChart.prototype.addCommandAvailabilityListener = function (listener) {
        this.i.addCommandAvailabilityListener(listener);
    };
    IgrDomainChart.prototype.removeCommandAvailabilityListener = function (listener) {
        this.i.removeCommandAvailabilityListener(listener);
    };
    IgrDomainChart.prototype.addCommandStateChangedListener = function (listener) {
        this.i.addCommandStateChangedListener(listener);
    };
    IgrDomainChart.prototype.removeCommandStateChangedListener = function (listener) {
        this.i.removeCommandStateChangedListener(listener);
    };
    IgrDomainChart.prototype.notifySetItem = function (source_, index, oldItem, newItem) {
        this.i.sl(source_, index, oldItem, newItem);
    };
    /**
     * Used to manually notify the chart that the data source has reset or cleared its items.
    
    *
    * Use `notifyClearItems` method to notifies the chart that the items have been cleared from an associated data source.
    *
    * ```ts
    * this.chart.notifyClearItems(this.data);
    * ```
    */
    IgrDomainChart.prototype.notifyClearItems = function (source_) {
        this.i.sh(source_);
    };
    IgrDomainChart.prototype.notifyInsertItem = function (source_, index, newItem) {
        this.i.si(source_, index, newItem);
    };
    IgrDomainChart.prototype.notifyRemoveItem = function (source_, index, oldItem) {
        this.i.sj(source_, index, oldItem);
    };
    Object.defineProperty(IgrDomainChart.prototype, "seriesAdded", {
        /**
         * Event raised when a series is initialized and added to this chart.
        *
        * `SeriesAdded` event raised when a series is initialized and added to this chart.
        *
        * ````ts
        *  <IgrCategoryChart
        * 	width="100%"
        * 	height="100%"
        * 	chartType="Line"
        * 	markerTypes={this.state.markersTypes}
        * 	dataSource={this.categoryData}
        * 	seriesAdded={this.CategoryChart_SeriesAdded}/>
        * ``
        *
        * ```ts
        * CategoryChart_SeriesAdded(sender:any ,aregs:ChartSeriesEventArgs)
        * {
        * }
        * ````
        */
        get: function () {
            return this._seriesAdded;
        },
        set: function (ev) {
            var _this = this;
            if (this._seriesAdded_wrapped !== null) {
                this.i.seriesAdded = delegateRemove(this.i.seriesAdded, this._seriesAdded_wrapped);
                this._seriesAdded_wrapped = null;
                this._seriesAdded = null;
            }
            this._seriesAdded = ev;
            this._seriesAdded_wrapped = function (o, e) {
                var outerArgs = new IgrChartSeriesEventArgs();
                outerArgs._provideImplementation(e);
                if (_this.beforeSeriesAdded) {
                    _this.beforeSeriesAdded(_this, outerArgs);
                }
                if (_this._seriesAdded) {
                    _this._seriesAdded(_this, outerArgs);
                }
            };
            this.i.seriesAdded = delegateCombine(this.i.seriesAdded, this._seriesAdded_wrapped);
            ;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "seriesRemoved", {
        /**
         * Event raised when a series is removed from this chart.
        *
        * `SeriesRemoved` event raised when a series is removed from this chart.
        *
        * ```ts
        *  <IgrCategoryChart
        * 	width="100%"
        * 	height="100%"
        * 	chartType="Line"
        * 	markerTypes={this.state.markersTypes}
        * 	dataSource={this.categoryData}
        * 	seriesRemoved={this.CategoryChart_seriesRemoved}/>
        * ```
        *
        * ```ts
        *  CategoryChart_seriesRemoved(sender: any , aregs: ChartSeriesEventArgs)
        *   {
        *
        *   }
        * ```
        */
        get: function () {
            return this._seriesRemoved;
        },
        set: function (ev) {
            var _this = this;
            if (this._seriesRemoved_wrapped !== null) {
                this.i.seriesRemoved = delegateRemove(this.i.seriesRemoved, this._seriesRemoved_wrapped);
                this._seriesRemoved_wrapped = null;
                this._seriesRemoved = null;
            }
            this._seriesRemoved = ev;
            this._seriesRemoved_wrapped = function (o, e) {
                var outerArgs = new IgrChartSeriesEventArgs();
                outerArgs._provideImplementation(e);
                if (_this.beforeSeriesRemoved) {
                    _this.beforeSeriesRemoved(_this, outerArgs);
                }
                if (_this._seriesRemoved) {
                    _this._seriesRemoved(_this, outerArgs);
                }
            };
            this.i.seriesRemoved = delegateCombine(this.i.seriesRemoved, this._seriesRemoved_wrapped);
            ;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "seriesPointerEnter", {
        /**
         * Occurs when the pointer enters a Series.
        *
        * `SeriesPointerEnter` event raised when the pointer enters a Series.
        *
        * ```ts
        *  <IgrCategoryChart
        * 	width="100%"
        * 	height="100%"
        * 	chartType="Line"
        * 	markerTypes={this.state.markersTypes}
        * 	dataSource={this.categoryData}
        * 	seriesPointerEnter={this.CategoryChart_seriesPointerDown}/>
        * ```
        *
        * ```ts
        * CategoryChart_seriesPointerEnter(sender: any , aregs: ChartSeriesEventArgs)
        *   {
        *
        *   }
        * ```
        */
        get: function () {
            return this._seriesPointerEnter;
        },
        set: function (ev) {
            var _this = this;
            if (this._seriesPointerEnter_wrapped !== null) {
                this.i.seriesPointerEnter = delegateRemove(this.i.seriesPointerEnter, this._seriesPointerEnter_wrapped);
                this._seriesPointerEnter_wrapped = null;
                this._seriesPointerEnter = null;
            }
            this._seriesPointerEnter = ev;
            this._seriesPointerEnter_wrapped = function (o, e) {
                var outerArgs = new IgrDomainChartSeriesPointerEventArgs();
                outerArgs._provideImplementation(e);
                if (_this.beforeSeriesPointerEnter) {
                    _this.beforeSeriesPointerEnter(_this, outerArgs);
                }
                if (_this._seriesPointerEnter) {
                    _this._seriesPointerEnter(_this, outerArgs);
                }
            };
            this.i.seriesPointerEnter = delegateCombine(this.i.seriesPointerEnter, this._seriesPointerEnter_wrapped);
            ;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "seriesPointerLeave", {
        /**
         * Occurs when the pointer leaves a Series.
        *
        * `SeriesPointerLeave` event raised when the pointer leaves a Series.
        *
        * ```ts
        *  <IgrCategoryChart
        * 	width="100%"
        * 	height="100%"
        * 	chartType="Line"
        * 	markerTypes={this.state.markersTypes}
        * 	dataSource={this.categoryData}
        * 	seriesPointerLeave={this.CategoryChart_seriesPointerLeave}/>
        * ```
        *
        * ```ts
        * CategoryChart_seriesPointerLeave(sender: any , aregs: ChartSeriesEventArgs)
        *   {
        *
        *   }
        * ```
        */
        get: function () {
            return this._seriesPointerLeave;
        },
        set: function (ev) {
            var _this = this;
            if (this._seriesPointerLeave_wrapped !== null) {
                this.i.seriesPointerLeave = delegateRemove(this.i.seriesPointerLeave, this._seriesPointerLeave_wrapped);
                this._seriesPointerLeave_wrapped = null;
                this._seriesPointerLeave = null;
            }
            this._seriesPointerLeave = ev;
            this._seriesPointerLeave_wrapped = function (o, e) {
                var outerArgs = new IgrDomainChartSeriesPointerEventArgs();
                outerArgs._provideImplementation(e);
                if (_this.beforeSeriesPointerLeave) {
                    _this.beforeSeriesPointerLeave(_this, outerArgs);
                }
                if (_this._seriesPointerLeave) {
                    _this._seriesPointerLeave(_this, outerArgs);
                }
            };
            this.i.seriesPointerLeave = delegateCombine(this.i.seriesPointerLeave, this._seriesPointerLeave_wrapped);
            ;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "seriesPointerMove", {
        /**
         * Occurs when the pointer moves over a Series.
        *
        * `SeriesPointerMove` event raised when the pointer moves over a Series.
        *
        * ```ts
        *  <IgrCategoryChart
        * 	width="100%"
        * 	height="100%"
        * 	chartType="Line"
        * 	markerTypes={this.state.markersTypes}
        * 	dataSource={this.categoryData}
        * 	seriesPointerMove={this.CategoryChart_seriesPointerMove}/>
        * ```
        *
        * ```ts
        *  CategoryChart_seriesPointerMove(sender: any , aregs: ChartSeriesEventArgs)
        *   {
        *
        *   }
        * ```
        */
        get: function () {
            return this._seriesPointerMove;
        },
        set: function (ev) {
            var _this = this;
            if (this._seriesPointerMove_wrapped !== null) {
                this.i.seriesPointerMove = delegateRemove(this.i.seriesPointerMove, this._seriesPointerMove_wrapped);
                this._seriesPointerMove_wrapped = null;
                this._seriesPointerMove = null;
            }
            this._seriesPointerMove = ev;
            this._seriesPointerMove_wrapped = function (o, e) {
                var outerArgs = new IgrDomainChartSeriesPointerEventArgs();
                outerArgs._provideImplementation(e);
                if (_this.beforeSeriesPointerMove) {
                    _this.beforeSeriesPointerMove(_this, outerArgs);
                }
                if (_this._seriesPointerMove) {
                    _this._seriesPointerMove(_this, outerArgs);
                }
            };
            this.i.seriesPointerMove = delegateCombine(this.i.seriesPointerMove, this._seriesPointerMove_wrapped);
            ;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "seriesPointerDown", {
        /**
         * Occurs when the pointer is pressed down over a Series.
        *
        * `SeriesPointerDown` event raised when the pointer is pressed down over a Series
        *
        * ````ts
        *  <IgrCategoryChart
        * 	width="100%"
        * 	height="100%"
        * 	chartType="Line"
        * 	markerTypes={this.state.markersTypes}
        * 	dataSource={this.categoryData}
        * 	seriesPointerDown={this.CategoryChart_seriesPointerDown}/>
        * ``
        *
        * ```ts
        * CategoryChart_seriesPointerDown(sender: any , aregs: ChartSeriesEventArgs)
        *   {
        *
        *   }
        * ````
        */
        get: function () {
            return this._seriesPointerDown;
        },
        set: function (ev) {
            var _this = this;
            if (this._seriesPointerDown_wrapped !== null) {
                this.i.seriesPointerDown = delegateRemove(this.i.seriesPointerDown, this._seriesPointerDown_wrapped);
                this._seriesPointerDown_wrapped = null;
                this._seriesPointerDown = null;
            }
            this._seriesPointerDown = ev;
            this._seriesPointerDown_wrapped = function (o, e) {
                var outerArgs = new IgrDomainChartSeriesPointerEventArgs();
                outerArgs._provideImplementation(e);
                if (_this.beforeSeriesPointerDown) {
                    _this.beforeSeriesPointerDown(_this, outerArgs);
                }
                if (_this._seriesPointerDown) {
                    _this._seriesPointerDown(_this, outerArgs);
                }
            };
            this.i.seriesPointerDown = delegateCombine(this.i.seriesPointerDown, this._seriesPointerDown_wrapped);
            ;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "seriesPointerUp", {
        /**
         * Occurs when the pointer is released over a Series.
        *
        * `SeriesPointerUp` event raised when the pointer is released over a Series.
        *
        * ```ts
        *  <IgrCategoryChart
        * 	width="100%"
        * 	height="100%"
        * 	chartType="Line"
        * 	markerTypes={this.state.markersTypes}
        * 	dataSource={this.categoryData}
        * 	seriesPointerUp={this.CategoryChart_seriesPointerUp}/>
        * ```
        *
        * ```ts
        *  CategoryChart_seriesPointerUp(sender: any , aregs: ChartSeriesEventArgs)
        *   {
        *
        *   }
        * ```
        */
        get: function () {
            return this._seriesPointerUp;
        },
        set: function (ev) {
            var _this = this;
            if (this._seriesPointerUp_wrapped !== null) {
                this.i.seriesPointerUp = delegateRemove(this.i.seriesPointerUp, this._seriesPointerUp_wrapped);
                this._seriesPointerUp_wrapped = null;
                this._seriesPointerUp = null;
            }
            this._seriesPointerUp = ev;
            this._seriesPointerUp_wrapped = function (o, e) {
                var outerArgs = new IgrDomainChartSeriesPointerEventArgs();
                outerArgs._provideImplementation(e);
                if (_this.beforeSeriesPointerUp) {
                    _this.beforeSeriesPointerUp(_this, outerArgs);
                }
                if (_this._seriesPointerUp) {
                    _this._seriesPointerUp(_this, outerArgs);
                }
            };
            this.i.seriesPointerUp = delegateCombine(this.i.seriesPointerUp, this._seriesPointerUp_wrapped);
            ;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "calloutStyleUpdating", {
        /**
         * Occurs when the style of a callout is updated.
        */
        get: function () {
            return this._calloutStyleUpdating;
        },
        set: function (ev) {
            var _this = this;
            if (this._calloutStyleUpdating_wrapped !== null) {
                this.i.calloutStyleUpdating = delegateRemove(this.i.calloutStyleUpdating, this._calloutStyleUpdating_wrapped);
                this._calloutStyleUpdating_wrapped = null;
                this._calloutStyleUpdating = null;
            }
            this._calloutStyleUpdating = ev;
            this._calloutStyleUpdating_wrapped = function (o, e) {
                var outerArgs = new IgrCalloutStyleUpdatingEventArgs();
                outerArgs._provideImplementation(e);
                if (_this.beforeCalloutStyleUpdating) {
                    _this.beforeCalloutStyleUpdating(_this, outerArgs);
                }
                if (_this._calloutStyleUpdating) {
                    _this._calloutStyleUpdating(_this, outerArgs);
                }
            };
            this.i.calloutStyleUpdating = delegateCombine(this.i.calloutStyleUpdating, this._calloutStyleUpdating_wrapped);
            ;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDomainChart.prototype, "calloutRenderStyleUpdating", {
        /**
         * Occurs when the style of a callout is updated.
        */
        get: function () {
            return this._calloutRenderStyleUpdating;
        },
        set: function (ev) {
            var _this = this;
            if (this._calloutRenderStyleUpdating_wrapped !== null) {
                this.i.calloutRenderStyleUpdating = delegateRemove(this.i.calloutRenderStyleUpdating, this._calloutRenderStyleUpdating_wrapped);
                this._calloutRenderStyleUpdating_wrapped = null;
                this._calloutRenderStyleUpdating = null;
            }
            this._calloutRenderStyleUpdating = ev;
            this._calloutRenderStyleUpdating_wrapped = function (o, e) {
                var outerArgs = new IgrCalloutRenderStyleUpdatingEventArgs();
                outerArgs._provideImplementation(e);
                if (_this.beforeCalloutRenderStyleUpdating) {
                    _this.beforeCalloutRenderStyleUpdating(_this, outerArgs);
                }
                if (_this._calloutRenderStyleUpdating) {
                    _this._calloutRenderStyleUpdating(_this, outerArgs);
                }
            };
            this.i.calloutRenderStyleUpdating = delegateCombine(this.i.calloutRenderStyleUpdating, this._calloutRenderStyleUpdating_wrapped);
            ;
        },
        enumerable: false,
        configurable: true
    });
    return IgrDomainChart;
}(React.Component));
export { IgrDomainChart };
